/**
 * @title eddService.js: Feature level module
 * @description The module used for managing edd services.
 * 
 */
define([], function() {
    var EDDService ={
    		
    		/**
    	     * Fires the EDDServiceLoaded event.
    	     */
    	    loaded: function() {
    	      COSTCO.Global.notify('EDDServiceLoaded');
    	    }, 	    
    	    
    	    locationDataExists : undefined,
    	      
    		/**
    		   * Method call calendar services from the JSON request build in currentOrderDataBean
    		   */
    		  callEddService: function(message) {

    			  try {
    		          var request = $('#calendarJson').val();
    		          var requestParameters = JSON.parse(decodeURIComponent(request));
    		          if(null != requestParameters[0].postalCode && null != requestParameters[0].stateCode && null != requestParameters[0].country){
    		        	  EDDService.locationDataExists = true;
    		          } else{
    		        	  EDDService.locationDataExists = false;
    		        	  console.log("In callEddService the postalCode is " + requestParameters[0].postalCode);
    		        	  console.log("In callEddService the stateCode is " + requestParameters[0].stateCode);
    		        	  console.log("In callEddService the country is " + requestParameters[0].country);
    		          }
    		          if (request !== undefined && null !== request && request.length>0) {
    		        	  if(checkoutPage === 'cart' || $('.primary-button-green-v2').val()=='Place Order'
    		        		  || $('.primary-button-green-v2').val()=='Passer ma commande'){
    		        		  if(EDDService.locationDataExists){
    		        			  COSTCO.EDDService.invokeEddAPI(request,message);
    		        		  } else{
    		        			// use 500ms setTimeout to give time for inv location cookies to be set before invoking EDD API
    		        			  setTimeout(() => {COSTCO.EDDService.invokeEddAPI(request,message)}, 500);
    		        		  }
    		              
    		        	  }
    		          }
    			  }catch(err) {
    				  console.log(' Apigee Responses Exception Occured Due to '+err);
    				$('.checkout-calender-spinner').addClass('hidden');
                    COSTCO.EDDService.disableOrEnableProceedButton('removeAttr');
                    $('.selection-item').removeClass('ajax-busy');
    			  }
    		      },
    		      /**
    		       * Method invoke calendar service only for reload flow. for quantity update ,remove and date selection response will take 
    		       * from JSP hidden variables If calendar API failed ,AJAX call invokes for removing calendar details of items.
    		       */
    		      invokeEddAPI: function(requestJson,message) {
    		    	  let finalGrocerySmallpackMap= new Map();
    		          let finalCalendarMap = new Map();
    		          let finalEddMap = new Map();
    		          let finalMessageCodeMap = new Map();
    		          let finalInstallationRequestMap = new Map();
    		          let finalShipCodeMap = new Map();
    		          let finalSmallPackSupplierDateMap=new Map();
    		          let finalSmallPackMap = new Map();
    		          var eddServiceInfoForSync = {
    		              fulfilledByEddMap: new Map(),
    		              fulfilledByItemLevelMap: new Map(),
    		              fulfillCalendarMap: new Map(),
    		              InvalidFulfilledBy: [],
    		              eddOnlyFulfilledBy: [],
    		              fulfilledByOrderIdMap : new Map()
    		          };
    		          var smallpackEligibleGroceryItems=$('#smallPackGroceryEligibleItems').val();
    		          var requiredKeys = $('#orderitemAndShipModeList').val();
    		          var smallPackKeys = $('#smallPackEligibleItems').val();
    		          if (requiredKeys !== undefined && null !== requiredKeys && requiredKeys.length>0) {
    		              requiredKeys = requiredKeys.replace('[', '').replace(']', ' ').replace(/\s+/g, '').split(',');
    		          }
    		          if (smallPackKeys !== undefined && null !== smallPackKeys && smallPackKeys.length>0) {
    		        	  smallPackKeys = smallPackKeys.replace('[', '').replace(']', ' ').replace(/\s+/g, '').split(',');
    		          }
    		          var hasFreeGift = $('#hasFreeGiftsInOrder').val();
    		          var calendarResponse = $('#calendarServiceResponse').val();
    		          if (hasFreeGift || (calendarResponse === "" && (typeof apiAlreadyCalled === 'undefined' || message === 'addressChange'))) {
    		                  var costcoEnv = $('#costcoEnvironmentForEDD').val();
    		                  if (costcoEnv == "") {
    		                      costcoEnv = 'ECOM';
    		                  } else if (costcoEnv == "DEV") {
    		                      costcoEnv = 'QA3';
    		                  }
    		                  var baseUri = $('#baseUriForEDD').val();
    		                  
    		                  var eddConnectionTime = $('#connectionTimeOutForEDD').val();
    		                  var smallPackConnectiontimeOut=$('#baseUriConnectionTimeOutForSmallPack').val();
    		                  var serviceTimeOut='';
    		                  $('.checkout-calender-spinner').removeClass('hidden');
    		                  $('.selection-item').addClass('ajax-busy');
    		                  COSTCO.EDDService.disableOrEnableProceedButton('setAttribute');
    		                  var rollBackTime= COSTCO.EDDService.getRollbackTime(requestJson,eddConnectionTime,smallPackConnectiontimeOut);
      		    			
    		                  function rollBackDisabledButton(){
                                  $('.checkout-calender-spinner').addClass('hidden');
                                  COSTCO.EDDService.disableOrEnableProceedButton('removeAttr');
                                  $('.selection-item').removeClass('ajax-busy');
                                  console.log('Apigee EDD Service Spinner Waiting Time : '+rollBackTime +'Sec');
    		    				}
    		                   	setTimeout(rollBackDisabledButton, rollBackTime);
    		                  
    		                  
    		                  var responseCount = 0;
    		                  let jsonDataForDBSave = {
    		                      mode: 'APICALL',
    		                      orderId: $('input[name=orderId]').val(),
    		                      orderItemsSpecificFulfilledBy : new Map(),
    		                      orderItemsSpecificFulfilledType : new Map(),
    		                      orderItemsSupplierAvailabilityDate: new Map(),
    		                      orderItemsTransportPriority : new Map(),
    		                      orderItemsSupplier : new Map(),
    		                      EDDRequestTransactionId: new Map(),
    		                      orderItemWebCatalogId: new Map()
    		                  };
    		                  var responseJson = '';
    		                  var deliveryServicesUri = $('#baseUriForEDDDeliveryServices').val();
                              var clientIdentifier=$('#apigeeClientIdentifierHeader').val();
                              var eddVendor;
                              var requestJsonList = JSON.parse(decodeURIComponent(requestJson));
    		                  for (var z = 0; z < requestJsonList.length; z++) {
    		                	  var isAlternateCapacityOrder = $('#isAlternateCapacityOrder_' + requestJsonList[z].orderItemId).val();
                                  if(typeof isAlternateCapacityOrder !== 'undefined' && isAlternateCapacityOrder !== null 
                                          && isAlternateCapacityOrder !== '' && isAlternateCapacityOrder==='true'){
                                      isAlternateCapacityOrder='y';
                                  }else{
                                      isAlternateCapacityOrder='n';
                                  }
    		                      var requestparams = requestJsonList[z];
    		                      var eddUrl='' ;
    		                      eddVendor = requestparams.vendorName;
    		                      if (requestparams.shipCodes) {
    		                        var shipCodesList=requestparams.shipCodes;
    		                        var shipCodes = shipCodesList.join('~');
    		                      }
    		                      var installationURI = '';

    		                      // SFSTRY0015001 prevent null values from cart for postal code and state from being passed in the EDD call
    		                      if (!EDDService.locationDataExists){
    		                    	  if(null == requestparams.postalCode){
    		                    		  requestparams.postalCode = $.cookie('invCheckPostalCode');
    		                    	  }
    		                    	  if(null == requestparams.stateCode){
    		                    		  requestparams.stateCode = $.cookie('invCheckStateCode');
    		                    	  }
    		                      }
    		                      
    		                      eddUrl = baseUri + '/' +  requestparams.mfPartNumber+"?destinationState="+requestparams.stateCode+"&destinationPostalCode="+requestparams.postalCode+
        		                      "&destinationCountryCode="+ requestparams.country+"&quantity="+ requestparams.quantity+"&orderItemId="+requestparams.orderItemId
        		                      +"&action=EDD";
    		                      if(!(checkoutPage === 'cart' || checkoutPage === 'review')){
    		                    	  eddUrl+"&tvonly="+isAlternateCapacityOrder;
    		                      }
    		                      if(shipCodes) {
    		                    	eddUrl += "&shippingCodes="+shipCodes;  
    		                      }
    		                      if (eddVendor == '[edd:tire]') {
    		                    	  eddUrl += "&whNum="+requestparams.warehouse;
    		                      }
    		                    	   serviceTimeOut= eddConnectionTime;
    		                    	  if (!COSTCO.util.isCAStore() && eddVendor!==undefined && !eddVendor.includes('smallpack') && !eddVendor.includes('chubltl') && !eddVendor.includes('[edd:tire]')) {
    		                    		   if (COSTCO.util.isLTLDeliveryServicesEnabled()) {
    		                    			   
    		                    			   installationURI = deliveryServicesUri + '/' + requestparams.mfPartNumber+"?destinationPostalCode="+requestparams.postalCode + "&orderItemId=" + requestparams.orderItemId;
    		                    			   if(requestparams.shipCodes && requestparams.shipCodes.length > 0){
    		                    				   installationURI += "&shipMode=" + requestparams.shipCodes[0];
    		                    			   } 
    		                    			   
    		                    			   finalInstallationRequestMap.set(requestparams.orderItemId, installationURI);
    		                    		   }
    		                    	   }
    		                      
    		                      const timeOutController = COSTCO.util.getTimeoutController();
    		                      apiAlreadyCalled = true;
    		                      var costcoService="restInventory";	
    		                      timeOutController(serviceTimeOut, fetch(eddUrl, {
    		                              method: 'GET',
    		                              headers: {
                                             "costco.env": costcoEnv,
                                             "client-identifier" : clientIdentifier,
                                             "costco.service" : costcoService
    		                              }
    		                          }))
    		                          .then((resp) => resp.json()) // Transform the data into json
    		                          .then(function(jsonResponse) {

    		                        	// Temp Fix until we get service response field "deliveredbBy" or other solution for CA EDD Calendars  
    		         			    	var canadaCommonEddCalendarEnabled = false;
    		         			    	if ((null!==$('#canadaCommonEddCalendarEnabled').val()) && (undefined!==$('#canadaCommonEddCalendarEnabled').val())){
    		         			    		canadaCommonEddCalendarEnabled=$('#canadaCommonEddCalendarEnabled').length > 0 && $('#canadaCommonEddCalendarEnabled').val()=='true' ? true:false;
    		         			    	}
    		         			    	if(COSTCO.util.isCAStore() && canadaCommonEddCalendarEnabled && jsonResponse.itemClassification != "SMALLPACK" && jsonResponse.itemClassification != "CHUBLTL"){
  		                        		  jsonResponse.fulfilledBy = 'MTH';
    		         			    	} 
		         			    	
    		                              responseCount++;
    		                             
    		         				     if(null!==jsonResponse.shipmodeDates && undefined!==jsonResponse.shipmodeDates 
    		         				    		 && jsonResponse.shipmodeDates.length >0 && jsonResponse.shipmodeDates[0].estimatedDeliveryDate !== undefined ){
    		         				    	 if((jsonResponse.shipmodeDates[0].supplierAvailabilityDate !== undefined && jsonResponse.shipmodeDates[0].supplierAvailabilityDate !== null)){
    		         				    		 jsonDataForDBSave.orderItemsSupplierAvailabilityDate.set(jsonResponse.orderItemId ,jsonResponse.shipmodeDates[0].supplierAvailabilityDate);
    		         				    	 }else{
    		         				    		 jsonDataForDBSave.orderItemsSupplierAvailabilityDate.set(jsonResponse.orderItemId,'DELETE');
    		         				    	 }
    		                             }
    		         				     
                                         if (null!==jsonResponse.shipmodeDates && undefined!==jsonResponse.shipmodeDates 
                                             && jsonResponse.shipmodeDates.length >0) {
                                           if ((jsonResponse.shipmodeDates[0].supplier !== undefined && jsonResponse.shipmodeDates[0].supplier !== null)){
                                             jsonDataForDBSave.orderItemsSupplier.set(jsonResponse.orderItemId ,jsonResponse.shipmodeDates[0].supplier);
                                           } else {
                                             jsonDataForDBSave.orderItemsSupplier.set(jsonResponse.orderItemId,'DELETE');
                                           }
                                         }
                                         
                                         if (null!==jsonResponse.shipmodeDates && undefined!==jsonResponse.shipmodeDates 
                                                 && jsonResponse.shipmodeDates.length >0 ) {
                                           if((jsonResponse.shipmodeDates[0].transportPriority !== undefined && jsonResponse.shipmodeDates[0].transportPriority !== null)){
                                             jsonDataForDBSave.orderItemsTransportPriority.set(jsonResponse.orderItemId ,jsonResponse.shipmodeDates[0].transportPriority);
                                           } else {
                                             jsonDataForDBSave.orderItemsTransportPriority.set(jsonResponse.orderItemId,'DELETE');
                                           }
                                         }
    		                             if ((jsonResponse.fulfilledBy !== undefined && jsonResponse.fulfilledBy !== null) || 
    		                            		  (jsonResponse.shipmodeDates !== undefined && jsonResponse.shipmodeDates !== null)) {
    		                            	 if (jsonResponse.fulfilledBy !== undefined && jsonResponse.fulfilledBy !== null){
    		                            		 jsonDataForDBSave.orderItemsSpecificFulfilledBy.set(jsonResponse.orderItemId,jsonResponse.fulfilledBy);
    		                            	 }
    		                                 responseJson = responseJson + JSON.stringify(jsonResponse) + '|';
    		                                 COSTCO.EDDService.buildFinalMapFromJson(jsonResponse, finalCalendarMap, requiredKeys, finalEddMap,
    		                                		 finalMessageCodeMap, finalInstallationRequestMap, eddServiceInfoForSync,
    		                                		 finalShipCodeMap,finalSmallPackSupplierDateMap,finalSmallPackMap,finalGrocerySmallpackMap);
    		                             }
    		                             if(jsonResponse.fulfillmentType !== undefined && jsonResponse.fulfillmentType !== '' ) {
   		                            	  jsonDataForDBSave.orderItemsSpecificFulfilledType.set(jsonResponse.orderItemId, jsonResponse.fulfillmentType);
   		                              }
    		                              if(jsonResponse.eddRequestTransactionId !== undefined && jsonResponse.eddRequestTransactionId !== '' ) {
    		                            	  jsonDataForDBSave.EDDRequestTransactionId.set(jsonResponse.orderItemId, jsonResponse.eddRequestTransactionId);
    		                              } 
    		                              if(jsonResponse.webCatalogId !== undefined && jsonResponse.webCatalogId !== ''){
    		                            	  jsonDataForDBSave.orderItemWebCatalogId.set(jsonResponse.orderItemId,jsonResponse.webCatalogId);
    		                              }
    		                              
    		                              if (jsonResponse.availableForSale == false) {
    		                            	  finalInstallationRequestMap.delete(jsonResponse.orderItemId);
    		                              }
    		                              
    		                              if (requestJsonList.length === responseCount) {
    		                                  document.getElementById("installationServiceRequest").value = JSON.stringify([...finalInstallationRequestMap]);
    		                                  document.getElementById("calendarServiceResponse").value = responseJson;
    		                                  if(responseJson===''){
    		                                	  if(requiredKeys.constructor===Array){
        		                                      for (var k = 0; k < requiredKeys.length; k++) {
        		                                    	  finalMessageCodeMap.set(requiredKeys[k], "FAILURE+MSG_CODE_EXTERNAL_SERVICE_DOWN+FALSE");
        		                                      }
    		                                	  }
    		                                  }
    		                                  var orderItemsEligibleForDelete =  new Set();
    		                                  if(smallPackKeys.constructor===Array){
    		                                  for(var s=0;s< smallPackKeys.length; s++) {
    		                                	  if(smallPackKeys[s] !==undefined && smallPackKeys[s].split('_').length>=2){
    		                                	  if(  !smallpackEligibleGroceryItems.includes(smallPackKeys[s].split('_')[1])
    		                                			  && smallPackKeys[s].includes('selectedsmallpack')){
    		                                	  if(undefined ===finalShipCodeMap.get(smallPackKeys[s])){
    		                                		  orderItemsEligibleForDelete.add(smallPackKeys[s].split('_')[1]);
    		                                	  }
    		                                	  }
    		                                	  }
    		                                  }}
    		                                  
    		                                  if (finalEddMap.size !== requiredKeys.length || finalCalendarMap.size !== requiredKeys.length) {
    		                                	  if(requiredKeys.constructor===Array){
	    		                                      for (var k = 0; k < requiredKeys.length; k++) {
	    		                                    	 if( requiredKeys[k].length>0){
	    		                                    		 if(requiredKeys[k] !==undefined &&requiredKeys[k].split('_').length>=3){
			    		                                          if (undefined === finalEddMap.get(requiredKeys[k])) {
			    		                                              orderItemsEligibleForDelete.add(requiredKeys[k].split('_')[2]);
			    		                                          }
	    		                                    		 }
	    		                                    	 }
	    		                                     }
    		                                	  }
    		                                  }
    		                                  
    		                                  globalCalendarMap = finalCalendarMap;
    		                                  COSTCO.EDDService.populateDatesFromService(finalCalendarMap,  true, orderItemsEligibleForDelete,
    		                                      finalEddMap, finalMessageCodeMap, jsonDataForDBSave, 
    		                                      eddServiceInfoForSync,finalShipCodeMap,finalSmallPackSupplierDateMap,finalSmallPackMap,finalGrocerySmallpackMap);
    		                                  if (finalInstallationRequestMap.size > 0) {
    		                                      COSTCO.EDDService.invokeInstallationServices(finalInstallationRequestMap, jsonDataForDBSave);
    		                                  } else {
    		                                      COSTCO.OrderItems.ajaxCalendarDataUpdate(jsonDataForDBSave);

    		                                  }
    		                                  finalCalendarMap.clear();
    		                                  finalEddMap.clear();
    		                                  finalMessageCodeMap.clear();

    		                                  $('.checkout-calender-spinner').addClass('hidden');
    		                                  COSTCO.EDDService.disableOrEnableProceedButton('removeAttr');
    		                                  $('.selection-item').removeClass('ajax-busy');
    		                                  

    		                              }

    		                          })
    		                          .catch(err => {
    		                        	  console.log('Apigee Error Occurred: '+err);
    		                              responseCount++;
    		                              if (err.message !== undefined && err.message === 'API_TIMEOUT') {
    		                            	  jsonDataForDBSave.TIMEOUT_OCCURED = 'Y';
    		                              }
    		                              if (requestJsonList.length <= responseCount) {
    		                                  document.getElementById("calendarServiceResponse").value = responseJson;
    		                                  document.getElementById("installationServiceRequest").value = JSON.stringify([...finalInstallationRequestMap]);
    		                                  var orderItemsEligibleForDelete = new Set();
    		                                  if(smallPackKeys.constructor===Array){
	    		                                  for(var s=0;s< smallPackKeys.length; s++) {
	    		                                	  if(smallPackKeys[s]!==undefined && smallPackKeys[s].split('_').length>=2){
		    		                                	  if(!smallpackEligibleGroceryItems.includes(smallPackKeys[s].split('_')[1])
		    		                                			  && smallPackKeys[s].includes('selectedsmallpack')){
			    		                                	  if(undefined ===finalShipCodeMap.get(smallPackKeys[s])){
			    		                                		  orderItemsEligibleForDelete.add(smallPackKeys[s].split('_')[1]);
			    		                                		  
			    		                                	  }
		    		                                	  }
	    		                                	  }
	    		                                  }
    		                                  }
    		                                  
    		                                  if(responseJson===''){
    		                                	  if(requiredKeys.constructor===Array){
        		                                      for (k = 0; k < requiredKeys.length; k++) {
        		                                    	  finalMessageCodeMap.set(requiredKeys[k], "FAILURE+MSG_CODE_EXTERNAL_SERVICE_DOWN+FALSE");
        		                                      }
    		                                	  }
    		                                  }
    		                                  
    		                                  if (finalEddMap.size !== requiredKeys.length || finalCalendarMap.size !== requiredKeys.length) {
    		                                	  if(requiredKeys.constructor===Array){
	    		                                      for (var k = 0; k < requiredKeys.length; k++) {
	    		                                    	  if( requiredKeys[k].length > 0 ){
	    		                                    		  if(requiredKeys[k]!==undefined && requiredKeys[k].split('_').length>=3){
			    		                                          if (undefined === finalEddMap.get(requiredKeys[k])) {
			    		                                              orderItemsEligibleForDelete.add(requiredKeys[k].split('_')[2]);
			    		                                          }
		    		                                    	  }
	    		                                    	  }
	    		                                      }
	    		                                  }
    		                                  }
    		                                  globalCalendarMap = finalCalendarMap;
    		                                  if (finalMessageCodeMap.size > 0  || finalShipCodeMap.size > 0 || finalGrocerySmallpackMap.size > 0) {
    		                                      COSTCO.EDDService.populateDatesFromService(finalCalendarMap,  true, orderItemsEligibleForDelete, finalEddMap, finalMessageCodeMap,
    		                                    		  jsonDataForDBSave, eddServiceInfoForSync,
    		                                          finalShipCodeMap,finalSmallPackSupplierDateMap,finalSmallPackMap,finalGrocerySmallpackMap);
    		                                      if (finalInstallationRequestMap.size > 0) {
    		                                    	  COSTCO.EDDService.invokeInstallationServices(finalInstallationRequestMap, jsonDataForDBSave);
    		                                      } else {
    		                                          COSTCO.OrderItems.ajaxCalendarDataUpdate(jsonDataForDBSave);
    		                                      }
    		                                  } else {
    		                                	  jsonDataForDBSave.orderItemsEligibleForDelete = orderItemsEligibleForDelete;
    		                                      COSTCO.OrderItems.ajaxCalendarDataUpdate(jsonDataForDBSave);

    		                                      $('.checkout-calender-spinner').addClass('hidden');
    		                                      $('.selection-item').removeClass('ajax-busy');
    		                                      COSTCO.EDDService.disableOrEnableProceedButton('removeAttr');
    		                                  }
    		                                  finalCalendarMap.clear();
        		                              finalEddMap.clear();
        		                              finalMessageCodeMap.clear();

        		                              $('.checkout-calender-spinner').addClass('hidden');
        		                              COSTCO.EDDService.disableOrEnableProceedButton('removeAttr');
        		                              $('.selection-item').removeClass('ajax-busy');
    		                              }
    		                          })
    		                  }

    		          } else {
    		              var installationResponse = document.getElementById("installationServiceMap").value;
    		              if (installationResponse !== "") {
    		                  let finalInstallationMap = new Map(JSON.parse(installationResponse));
    		                  COSTCO.EDD.populateDeliveryServices(finalInstallationMap);
    		              }
    		              if(calendarResponse===''){
                        	  if(requiredKeys.constructor===Array){
                                  for (var k = 0; k < requiredKeys.length; k++) {
                                	  finalMessageCodeMap.set(requiredKeys[k], "FAILURE+MSG_CODE_EXTERNAL_SERVICE_DOWN+FALSE");
                                  }
                        	  }
                          }else{
	    		              var responses = calendarResponse.split('|');
	    		              for (var t = 0; t < responses.length; t++) {
	    		                  if (responses[t].length > 0) {
	    		                	  var savedJSON=JSON.parse(responses[t]);
	    		                	  if(savedJSON.orderItemId!=='0'){
	    		                      COSTCO.EDDService.buildFinalMapFromJson(savedJSON, finalCalendarMap, requiredKeys, finalEddMap,
	    		                          finalMessageCodeMap, null, eddServiceInfoForSync,
	    		                          finalShipCodeMap,finalSmallPackSupplierDateMap,finalSmallPackMap,finalGrocerySmallpackMap);
	    		                	  }
	    		                  }
	    		              }
	    		           
                          }
    		              COSTCO.EDDService.populateDatesFromService(finalCalendarMap, false, new Set() , finalEddMap, finalMessageCodeMap,
    		                  null,  eddServiceInfoForSync,
    		                  finalShipCodeMap,finalSmallPackSupplierDateMap,finalSmallPackMap,finalGrocerySmallpackMap);
    		              finalCalendarMap.clear();
    		              finalEddMap.clear();
    		              finalMessageCodeMap.clear();
    		              finalShipCodeMap.clear();
    		              finalSmallPackSupplierDateMap.clear();
    		              finalSmallPackMap.clear();
    		              $('.checkout-calender-spinner').addClass('hidden');
    		              COSTCO.EDDService.disableOrEnableProceedButton('removeAttr');
    		              $('.selection-item').removeClass('ajax-busy');
    		          }

    		      },
    		      invokeInstallationServices: function(finalInstallationRequestMap, jsonDataForDBSave) {
    		          var installationUri = '';
    		          var responseJson = '';
    		          let finalInstallationMap = new Map();
    		          var responseCount = 0;
    		          var clientIdentifier=$('#apigeeClientIdentifierHeader').val();
    		          var costcoEnv = $('#costcoEnvironmentForEDD').val();
    		          if (costcoEnv == "") {
    		              costcoEnv = 'ECOM';
    		          } else if (costcoEnv == 'DEV') {
    		              costcoEnv = 'QA3';
    		          }
    		          var installationConnectionTime = $('#connectionTimeOutForEDD').val();

    		          const timeOutController = COSTCO.util.getTimeoutController();

    		          for (var orderItem of finalInstallationRequestMap.keys()) {
    		              
    		                  installationUri = finalInstallationRequestMap.get(orderItem);
    		                      timeOutController(installationConnectionTime, fetch(installationUri, {
    		                          method: 'GET',
    		                          headers: {
    		                              "costco.env": costcoEnv,
    		                              "client-identifier" : clientIdentifier
    		                          }
    		                      }))
    		                      .then((resp) => resp.json()) // Transform the data into json
    		                      .then(function(jsonResponse) {          	  
    		                          responseCount++;
    		                          
    		                          if(jsonResponse.services!==undefined && jsonResponse.services.length>0){
    		                          responseJson = responseJson + JSON.stringify(jsonResponse) + '|';
    		                          if(undefined !== jsonResponse.orderItemId){
    		                        	  finalInstallationMap.set(jsonResponse.orderItemId, jsonResponse.services);
    		                          }
    		                          }
    		                          if (finalInstallationRequestMap.size == responseCount) {
    		                              document.getElementById("installationServiceResponse").value = responseJson;
    		                              if (finalInstallationMap.size > 0) {
    		                            	  jsonDataForDBSave.orderSpecificInstallationServices = JSON.stringify([...finalInstallationMap]);
    		                                  document.getElementById("installationServiceMap").value = JSON.stringify([...finalInstallationMap]);
    		                                  COSTCO.EDD.populateDeliveryServices(finalInstallationMap);
    		                              }
    		                              COSTCO.OrderItems.ajaxCalendarDataUpdate(jsonDataForDBSave);
    		                          }
    		                      }).catch(err => {
    		                          responseCount++;
    		                          if (finalInstallationRequestMap.size == responseCount) {
    		                              document.getElementById("installationServiceResponse").value = responseJson;
    		                              if (finalInstallationMap.size > 0) {
    		                            	  jsonDataForDBSave.orderSpecificInstallationServices = JSON.stringify([...finalInstallationMap]);
    		                                  COSTCO.EDD.populateDeliveryServices(finalInstallationMap);
    		                              }
    		                              COSTCO.OrderItems.ajaxCalendarDataUpdate(jsonDataForDBSave);
    		                          }
    		                      })

    		              
    		          }

    		      },
    		      
    		      /**
    		       * Method build a map with orderItemsId as key and  value  as map of dates and corresponding time slots
    		       */
    		      buildFinalMapFromJson: function(jsonResponse, finalCalendarMap, requiredKeys, finalEddMap, finalMessageCodeMap, 
    		    		  finalInstallationRequestMap, eddServiceInfoForSync,finalShipCodeMap,finalSmallPackSupplierDateMap,finalSmallPackMap,finalGrocerySmallpackMap) {
    		    	  
    		    	  if(jsonResponse.itemClassification=="SMALLPACK" || jsonResponse.itemClassification=="CHUBLTL"){
    		    		  COSTCO.EDDService.buildFinalMapForSmallPack(finalShipCodeMap,jsonResponse,finalSmallPackSupplierDateMap,finalSmallPackMap,finalGrocerySmallpackMap);
    		    	  }else{
    		    	  var isShipModeDatesExist = null!==jsonResponse.shipmodeDates && undefined!==jsonResponse.shipmodeDates 
			    		                           && jsonResponse.shipmodeDates.length > 0;
    		    	  var selectedOrderItemShipcodeList=$('#selectedOrderItemShipcodeList').val();
    		    	  var nonDeluxingItems=$('#nonDeluxingItems').val();
    		          var calendarEligibleItems=''+$('#calendarEligibleOrderItems').val();
    		          if (isShipModeDatesExist && jsonResponse.shipmodeDates[0].availableDeliveryDates && jsonResponse.shipmodeDates[0].availableDeliveryDates.length > 0) {
    		            var dates = jsonResponse.shipmodeDates[0].availableDeliveryDates;
    		          }
    		          let itemLevelCalendarMap = new Map();
    		          let scheduledDateAndTimeListMap = new Map();
    		          var startDate = null;
    		          var endDate = null;
    		          var formatedDate = null;
    		          var startTime = null;
    		          var endTime = null;
    		          var timeslot = null;
    		          var date = null;
    		          var timeList = null;
    				  
    		          if(calendarEligibleItems.includes(jsonResponse.orderItemId)){
    		        	  var orderList=[];
		        		  if (eddServiceInfoForSync.fulfilledByOrderIdMap.get(jsonResponse.fulfilledBy) === undefined) {
		        			  orderList.push(jsonResponse.orderItemId);
                              eddServiceInfoForSync.fulfilledByOrderIdMap.set(jsonResponse.fulfilledBy, orderList);
                          } else {
                        	  orderList = eddServiceInfoForSync.fulfilledByOrderIdMap.get(jsonResponse.fulfilledBy);
                        	  if(!orderList.includes(jsonResponse.orderItemId)){
                        		  orderList.push(jsonResponse.orderItemId);
	                              eddServiceInfoForSync.fulfilledByOrderIdMap.set(jsonResponse.fulfilledBy, orderList); 
                        	  }
                          }
		        		  if (null!==dates && undefined!==dates && dates.length>0){
		        			  for (var i = 0; i < dates.length; i++) {
		        				  startDate = dates[i].start;
		        				  endDate = dates[i].end;
		    		              formatedDate = null;
		    		              startTime = null;
		    		              endTime = null;
		    		              timeslot = null;
		    		              date = null;
		    		              timeList = null;
		    		              if (null !== startDate) {
		    		                  date = new Date(startDate);
		    		                  formatedDate = COSTCO.EDDService.formatCalendarDate(date);
		    		                  startTime = COSTCO.EDDService.formatAMPM(date);
		    		                  if (null !== endDate) {
		    		                      endTime = COSTCO.EDDService.formatAMPM(new Date(endDate));
		    		                      timeslot = startTime + '-' + endTime;
		    		                  }
		    		              }
		    		              if (scheduledDateAndTimeListMap.get(formatedDate) === undefined) {
		    		                  scheduledDateAndTimeListMap.set(formatedDate, timeslot)
		    		              } else {
		    		                  if (scheduledDateAndTimeListMap.get(formatedDate).constructor === String) {
		    		                      timeList = scheduledDateAndTimeListMap.get(formatedDate).split();
		    		                  } else {
		    		                      timeList = scheduledDateAndTimeListMap.get(formatedDate);
		    		                  }
		    		                  timeList.push(timeslot);
		    		                  scheduledDateAndTimeListMap.set(formatedDate, timeList);
		    		              }
		    		          }
		        		  }
    		          }else{
    		        	  if (!eddServiceInfoForSync.eddOnlyFulfilledBy.includes(jsonResponse.fulfilledBy)) {
                              eddServiceInfoForSync.eddOnlyFulfilledBy.push(jsonResponse.fulfilledBy);
                          }
    		          }
    		       
    		          var msgCode = COSTCO.EDDService.buildMessageCodeForEDD(jsonResponse);

    		          for (var k = 0; k < requiredKeys.length; k++) {
    		        	  if(COSTCO.util.isCAStore()){
	    		              if (requiredKeys[k].includes(jsonResponse.orderItemId)) {
	    		            	  if(calendarEligibleItems.includes(jsonResponse.orderItemId)  && msgCode.includes('SUCCESS')){
	    		            		  var mapList = [];
	    		                      finalCalendarMap.set(requiredKeys[k], scheduledDateAndTimeListMap);
	    		                      if (eddServiceInfoForSync.fulfillCalendarMap.get(jsonResponse.fulfilledBy) === undefined) {
			                              mapList.push(scheduledDateAndTimeListMap);
			                              eddServiceInfoForSync.fulfillCalendarMap.set(jsonResponse.fulfilledBy, mapList);
			                          } else {
			                              mapList = eddServiceInfoForSync.fulfillCalendarMap.get(jsonResponse.fulfilledBy);
			                              mapList.push(scheduledDateAndTimeListMap);
			                              eddServiceInfoForSync.fulfillCalendarMap.set(jsonResponse.fulfilledBy, mapList);
			                          }
	    		            	  }
	    		            	  
	    		                  if (isShipModeDatesExist && jsonResponse.shipmodeDates[0].estimatedDeliveryDate !== null) {
	    		                      finalEddMap.set(requiredKeys[k], jsonResponse.shipmodeDates[0].estimatedDeliveryDate);
	    		                  }
	    		                  if (isShipModeDatesExist && jsonResponse.shipmodeDates[0].estimatedDeliveryDate !== null) {
	    		                	  if (eddServiceInfoForSync.fulfilledByEddMap.get(jsonResponse.fulfilledBy) === undefined) {
	    		                		  eddServiceInfoForSync.fulfilledByEddMap.set(jsonResponse.fulfilledBy, jsonResponse.shipmodeDates[0].estimatedDeliveryDate);
	    		                      } else if (eddServiceInfoForSync.fulfilledByEddMap.get(jsonResponse.fulfilledBy) < jsonResponse.shipmodeDates[0].estimatedDeliveryDate) {
	    		                          eddServiceInfoForSync.fulfilledByEddMap.set(jsonResponse.fulfilledBy, jsonResponse.shipmodeDates[0].estimatedDeliveryDate);
	    		                      }
	    		                      finalEddMap.set(requiredKeys[k], eddServiceInfoForSync.fulfilledByEddMap.get(jsonResponse.fulfilledBy));
	    		                  } else {
	    		                	  if (!eddServiceInfoForSync.InvalidFulfilledBy.includes(jsonResponse.fulfilledBy)) {
	    		                		  eddServiceInfoForSync.InvalidFulfilledBy.push(jsonResponse.fulfilledBy);
	    		                      }
	    		                  }
	    		                  if (eddServiceInfoForSync.fulfilledByItemLevelMap.get(jsonResponse.fulfilledBy) === undefined) {
	    		                	  eddServiceInfoForSync.fulfilledByItemLevelMap.set(jsonResponse.fulfilledBy, requiredKeys[k])
	    		                  } else {
	    		                	  var idList = null;
	    		                      if (eddServiceInfoForSync.fulfilledByItemLevelMap.get(jsonResponse.fulfilledBy).constructor === String) {
	    		                    	  idList = eddServiceInfoForSync.fulfilledByItemLevelMap.get(jsonResponse.fulfilledBy).split();
	    		                      } else {
	    		                    	  idList = eddServiceInfoForSync.fulfilledByItemLevelMap.get(jsonResponse.fulfilledBy);
	    		                      }
	    		                      idList.push(requiredKeys[k]);
	    		                      eddServiceInfoForSync.fulfilledByItemLevelMap.set(jsonResponse.fulfilledBy, idList);
	    		                  }
	    		                  if (eddServiceInfoForSync.InvalidFulfilledBy.includes(jsonResponse.fulfilledBy)) {
	    		                	  msgCode = msgCode.replace('SUCCESS','FAILURE');
	    		                  }
	    		                         
	    		                  finalMessageCodeMap.set(requiredKeys[k], msgCode);
	    		              } else if (finalMessageCodeMap.get(requiredKeys[k]) === undefined) {
	    		                  finalMessageCodeMap.set(requiredKeys[k], "FAILURE+MSG_CODE_EXTERNAL_SERVICE_DOWN+FALSE");
	    		              }
    		          }else{
    		           if (requiredKeys[k].includes(jsonResponse.orderItemId)) {
    		        	   if(isShipModeDatesExist && nonDeluxingItems.includes(jsonResponse.orderItemId)){
    		        		   COSTCO.EDDService.getDefaultShipcodeForNonDeluxingItems(selectedOrderItemShipcodeList,jsonResponse);
    		        		   if(jsonResponse.shipmodeDates[0].estimatedDeliveryDate !== null){
     		        				  finalEddMap.set(requiredKeys[k], jsonResponse.shipmodeDates[0].estimatedDeliveryDate);
     		        			  }
     		        		  }else if (isShipModeDatesExist && requiredKeys[k].includes(jsonResponse.shipmodeDates[0].shippingCode) && 
     		        				 jsonResponse.shipmodeDates[0].estimatedDeliveryDate !== null) {
     		        			  finalEddMap.set(requiredKeys[k], jsonResponse.shipmodeDates[0].estimatedDeliveryDate);
     		        		  }
     		        			
     		        		if(isShipModeDatesExist && selectedOrderItemShipcodeList.includes(jsonResponse.orderItemId+'_'+jsonResponse.shipmodeDates[0].shippingCode)
         		        			  && requiredKeys[k].includes(jsonResponse.shipmodeDates[0].shippingCode)){
	     		            	 if(calendarEligibleItems.includes(jsonResponse.orderItemId)  && msgCode.includes('SUCCESS')){
     		            	      var mapList = [];
     		                      finalCalendarMap.set(requiredKeys[k], scheduledDateAndTimeListMap);
	     		            	   if (eddServiceInfoForSync.fulfillCalendarMap.get(jsonResponse.fulfilledBy) === undefined) {
	 		                              mapList.push(scheduledDateAndTimeListMap);
	 		                              eddServiceInfoForSync.fulfillCalendarMap.set(jsonResponse.fulfilledBy, mapList);
	
	 		                          } else {
	 		                              mapList = eddServiceInfoForSync.fulfillCalendarMap.get(jsonResponse.fulfilledBy);
	 		                              mapList.push(scheduledDateAndTimeListMap);
	 		                              eddServiceInfoForSync.fulfillCalendarMap.set(jsonResponse.fulfilledBy, mapList);
	 		                          }
	     		            	  }
	     		            	 
     		                      if (null!==jsonResponse.shipmodeDates && undefined!==jsonResponse.shipmodeDates 
     		                    		  && jsonResponse.shipmodeDates.length >0 && jsonResponse.shipmodeDates[0].estimatedDeliveryDate !== null) {
     		                    	  
     		                          if (eddServiceInfoForSync.fulfilledByEddMap.get(jsonResponse.fulfilledBy) === undefined) {
     		                              eddServiceInfoForSync.fulfilledByEddMap.set(jsonResponse.fulfilledBy, jsonResponse.shipmodeDates[0].estimatedDeliveryDate);
     		                          } else if (eddServiceInfoForSync.fulfilledByEddMap.get(jsonResponse.fulfilledBy) < jsonResponse.shipmodeDates[0].estimatedDeliveryDate) {
     		                              eddServiceInfoForSync.fulfilledByEddMap.set(jsonResponse.fulfilledBy, jsonResponse.shipmodeDates[0].estimatedDeliveryDate);
     		                          }
     		                          finalEddMap.set(requiredKeys[k], eddServiceInfoForSync.fulfilledByEddMap.get(jsonResponse.fulfilledBy));
     		                    	  
     		                      } else {
     		                          if (!eddServiceInfoForSync.InvalidFulfilledBy.includes(jsonResponse.fulfilledBy)) {
     		                              eddServiceInfoForSync.InvalidFulfilledBy.push(jsonResponse.fulfilledBy);
     		                          }
     		                      }
     		                      if (eddServiceInfoForSync.fulfilledByItemLevelMap.get(jsonResponse.fulfilledBy) === undefined) {
     		                          eddServiceInfoForSync.fulfilledByItemLevelMap.set(jsonResponse.fulfilledBy, requiredKeys[k])
     		                      } else {
     		                          var idList = null;
     		                          if (eddServiceInfoForSync.fulfilledByItemLevelMap.get(jsonResponse.fulfilledBy).constructor === String) {
     		                              idList = eddServiceInfoForSync.fulfilledByItemLevelMap.get(jsonResponse.fulfilledBy).split();
     		                          } else {
     		                              idList = eddServiceInfoForSync.fulfilledByItemLevelMap.get(jsonResponse.fulfilledBy);
     		                          }
     		                          idList.push(requiredKeys[k]);
     		                          eddServiceInfoForSync.fulfilledByItemLevelMap.set(jsonResponse.fulfilledBy, idList);
     		                      }
     		                      if (eddServiceInfoForSync.InvalidFulfilledBy.includes(jsonResponse.fulfilledBy)) {
     		                    		  msgCode = msgCode.replace('SUCCESS','FAILURE');
     		                      }
    		        		   }
     		                         
     		                   finalMessageCodeMap.set(requiredKeys[k], msgCode);
     		              } else if (finalMessageCodeMap.get(requiredKeys[k]) === undefined) {
     		                  finalMessageCodeMap.set(requiredKeys[k], "FAILURE+MSG_CODE_EXTERNAL_SERVICE_DOWN+FALSE");
     		              }
    		        	  
    		          }
    		    	  }
    		    	  }

    		      },
    		      buildFinalMapForSmallPack: function(finalShipCodeMap,jsonResponse,finalSmallPackSupplierDateMap,finalSmallPackMap,finalGrocerySmallpackMap){
    		    		  var smallPackEligibleItems = $('#smallPackEligibleItems').val();
    		    		  var smallpackEligibleGroceryItems=$('#smallPackGroceryEligibleItems').val();
        		          if (smallPackEligibleItems !== undefined && null !== smallPackEligibleItems) {
        		        	  smallPackEligibleItems = smallPackEligibleItems.replace('[', '').replace(']', ' ').replace(/\s+/g, '').split(',');
        		        	  //smallPackEligibleItems = JSON.parse(smallPackEligibleItems);
        		          }
        		          var orderItemId=jsonResponse.orderItemId;
        		          var shipcode='';
        		          var edd='';
        		          var supplierDate=''
        		          var oldDate = null;
        		          var newDate = null;
        		          var firstDate = null;
        		          var eddData = new Map();
        		          var isSelected = false;
        		          var selectable = false;
        		          var hideShipMethod = false;
        		          var shipModeId;
        		          
    		    		  if(jsonResponse.shipmodeDates.length > 0){
    		    			  for(var k=0; k < jsonResponse.shipmodeDates.length ;k++){
    		    				  
    		    				  hideShipMethod = false;
    		    				  shipModeId = '';
    		    				  shipcode = jsonResponse.shipmodeDates[k].shippingCode;
    		    				  edd=jsonResponse.shipmodeDates[k].estimatedDeliveryDate;
    		    				  supplierDate=jsonResponse.shipmodeDates[k].supplierAvailabilityDate;
    		    				  
    		    				  if (null !== edd && smallpackEligibleGroceryItems!==undefined && 
		    		            	  smallpackEligibleGroceryItems.includes(orderItemId)) {
    		    					  newDate = Date.parse(edd);
    		    					 if(finalGrocerySmallpackMap.get('EDD')!==undefined){
    		    						 oldDate=Date.parse(finalGrocerySmallpackMap.get('EDD'));
    		    						 if(oldDate<newDate){
    		    					       finalGrocerySmallpackMap.set('EDD',edd);
    		    					       finalGrocerySmallpackMap.set('SUPPLIER_DATE',supplierDate);
    		    						 }
    		    					 }else{
    		    						 finalGrocerySmallpackMap.set('EDD',edd);
    		    						 finalGrocerySmallpackMap.set('SUPPLIER_DATE',supplierDate);
    		    					 }
    		    				  }else{
	    		    				  for (var j = 0; j < smallPackEligibleItems.length; j++) {
	    		    		              if (smallPackEligibleItems[j].includes(orderItemId) && smallPackEligibleItems[j].includes(shipcode)) {
	    		    		            	  finalShipCodeMap.set(smallPackEligibleItems[j],edd);
	    		    		            	  finalSmallPackSupplierDateMap.set(smallPackEligibleItems[j],supplierDate);
	    		    		            	  
	    		    		            	  if(smallPackEligibleItems[j].includes("selected")){
	    		        						  isSelected = true;
	    		        						  smallPackEligibleItems[j] = smallPackEligibleItems[j].replace('selected','');
	    		        					  } else {
	    		        						  isSelected = false;
	    		        					  }
	    		        						
	    		    		            	  if (firstDate == null) {
	    	    		    					  firstDate = edd;
	    	    		    					  selectable = true;
	    	    		    				  } else {
	    	    		    					  if (jsonResponse.shipmodeDates[k].estimatedDeliveryDate >= firstDate) {
	    	    		    						  hideShipMethod = true;
	    	    		    						  selectable = false;
	    	    		    					  }
	    	    		    				  }
	    		    		            	  if (smallPackEligibleItems[j].split('_').length >= 2 ) {
	    		    		            		  shipModeId = smallPackEligibleItems[j].split('_')[2];
	    		    		            	  }
	    		    		            		
	    		    		            	  eddData.set(shipcode,
		    									 {"screenField" : smallPackEligibleItems[j],
		    		            		  		  "edd" : edd, 
		    								 	  "supplierDate" : supplierDate,
		    								 	  "selected" : isSelected,
		    								 	  "selectable" : selectable,
		    								 	  "shipModeId" : shipModeId,
		    								 	  "hide" : hideShipMethod});
	    		    		            	  
	    		    		            	  finalSmallPackMap.set(orderItemId, eddData);
	    		    		              }
	    		    				  }
    		    				  }
    		    			  }
    		    		  }
        		          
               },
    		      buildMessageCodeForEDD: function(jsonResponse) {
    		          var msgString = '';
    		          var complexInstallation = 'FALSE';
    		          if (typeof jsonResponse.isComplex !== 'undefined' && null !== jsonResponse.isComplex && jsonResponse.isComplex) {
    		              complexInstallation = 'TRUE';
    		          }
    		          if (typeof jsonResponse.availableForSale !== 'undefined' && null !== jsonResponse.availableForSale && jsonResponse.availableForSale) {
    		              if (typeof jsonResponse.itemClassification !== 'undefined' && null !== jsonResponse.itemClassification 
    		                     && 'TIRE' !== jsonResponse.itemClassification.toUpperCase() && null !== jsonResponse.shipmodeDates && undefined !== jsonResponse.shipmodeDates 
    		                     && jsonResponse.shipmodeDates.length >0 && (typeof jsonResponse.shipmodeDates[0].estimatedDeliveryDate === 'undefined' || jsonResponse.shipmodeDates[0].estimatedDeliveryDate === null 
    		                     || jsonResponse.shipmodeDates[0].estimatedDeliveryDate !== null && jsonResponse.shipmodeDates[0].estimatedDeliveryDate.trim().length === 0)) {
    		            	  if (COSTCO.EDDService.isAdditionTransitTimeRequired()) {
        		                  msgString = 'SUCCESS+MSG_CODE_ADDITIONAL_TRANSIT_TIME+' + complexInstallation;
        		              } else {
        		            	  msgString = 'SUCCESS+MSG_CODE_AVAILABLE_INHOUSE+' + complexInstallation;
        		              }
        		          } else if (typeof jsonResponse.itemClassification !== 'undefined' && null !== jsonResponse.itemClassification 
        		                 && 'TIRE' === jsonResponse.itemClassification.toUpperCase() && typeof jsonResponse.availability !== 'undefined' && null !== jsonResponse.availability 
        		                 && 'NOSTOCK' !== jsonResponse.availability.toUpperCase()) {
        		              msgString = 'SUCCESS+MSG_CODE_AVAILABLE_INHOUSE+TRUE';
        		          }else if (typeof jsonResponse.itemClassification !== 'undefined' && null !== jsonResponse.itemClassification 
        		                 && 'TIRE' !== jsonResponse.itemClassification.toUpperCase() && null !== jsonResponse.shipmodeDates && undefined !== jsonResponse.shipmodeDates 
        		                 && jsonResponse.shipmodeDates.length >0 && (COSTCO.EDDService.checkIfEDDInValidRange(jsonResponse.shipmodeDates[0].estimatedDeliveryDate))) {
    		                  msgString = 'SUCCESS++' + complexInstallation;
    		              } else {
    		                  msgString = 'FAILURE+MSG_CODE_ITEM_OUT_OF_STOCK+' + complexInstallation;
    		              }

    		          } else {

    		              // If fulfilled by comes back with "ship restricted", show a different error message
    		              if ('ShipRestricted' === jsonResponse.fulfilledBy || COSTCO.util.productConstants.edd_shiprestricted === jsonResponse.availability) {
    		                  msgString = 'FAILURE+MSG_CODE_POSTAL_CODE_RESTRICTED+' + complexInstallation;
    		                  // if fulfilledBy = 'UNKNOWN' then an exception happened - date will be null
    		              } else if (jsonResponse.fulfilledBy !=null && 'UNKNOWN' === jsonResponse.fulfilledBy.toUpperCase()) {
    		                  msgString = 'FAILURE+MSG_CODE_UNKNOWN_ERROR+' + complexInstallation;
    		              } else {
    		                  msgString = 'FAILURE+MSG_CODE_ITEM_OUT_OF_STOCK+' + complexInstallation;
    		              }

    		          }
    		          
    		          
    		          return msgString;

    		      },
    		      /**
    		       * Method return date in yyyy-dd-mm-dd format
    		       */
    		      formatCalendarDate: function(date) {
    		    	  let timeZoneCorrectDate = new Date(date.getTime() + (date.getTimezoneOffset() * 60000));
		    	   	  if (date.getTimezoneOffset() < 0) {
	            		timeZoneCorrectDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
	             	  }
    		    	  date = timeZoneCorrectDate;
    		             var month = '' + (date.getMonth() + 1),
    		              day = '' + date.getDate(),
    		              year = date.getFullYear();

    		          if (month.length < 2)
    		              month = '0' + month;
    		          if (day.length < 2)
    		              day = '0' + day;

    		          return [year, month, day].join('-');
    		      },
    		      /**
    		       * Method return time in 12 hrs format with AM/PM.
    		       */
    		      formatAMPM: function(date) {
    		    	  let timeZoneCorrectDate = new Date(date.getTime() + (date.getTimezoneOffset() * 60000));
    		    	  // East of GMT
		    	   	  if (date.getTimezoneOffset() < 0) {
	            		timeZoneCorrectDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
	             	  }
    		    	  date = timeZoneCorrectDate;
    		          var hours = date.getHours();
    		          var minutes = date.getMinutes();
    		          var ampm = hours >= 12 ? 'PM' : 'AM';
    		          if (hours == 0) {
    		              hours = 12;
    		          } else {
    		              hours = hours % 12;
    		              hours = hours ? hours : 12;
    		          } // the hour '0' should be '12'
    		          minutes = minutes < 10 ? '0' + minutes : minutes;
    		          hours = hours < 10 ? '0' + hours : hours;
    		          var strTime = hours + ':' + minutes + ampm;
    		          return strTime;
    		      },
    		      /**
    		       * Method populates dates from services
    		       */
    		      populateDatesFromService: function(itemLevelCalendarMap,  eligibleForDBInsert, orderItemsEligibleForDelete, finalEddMap,
    		          finalMessageCodeMap, jsonDataForDBSave, 
    		          eddServiceInfoForSync,finalShipCodeMap,finalSmallPackSupplierDateMap,finalSmallPackMap,finalGrocerySmallpackMap) {
    		          var orderItemSpecificSelectedDate = new Map();
    		          var commonDateTimeStamp = '';
    		          var orderItemSpecificEdd = new Map();
    		          var storeId = $('#storeIdentifier').val();
    		      
		        	  COSTCO.EDDService.syncCalendarData(itemLevelCalendarMap, eddServiceInfoForSync, orderItemsEligibleForDelete, jsonDataForDBSave, eligibleForDBInsert, finalEddMap,finalMessageCodeMap);
		              COSTCO.EDDService.populateEddService(orderItemSpecificSelectedDate, commonDateTimeStamp, orderItemsEligibleForDelete, orderItemSpecificEdd,
		                  itemLevelCalendarMap, eligibleForDBInsert, finalEddMap,
		                  finalMessageCodeMap, jsonDataForDBSave, eddServiceInfoForSync);
		     
		              COSTCO.EDDService.populateSmallPackEDD(finalShipCodeMap,jsonDataForDBSave,
		            		  eligibleForDBInsert,finalSmallPackSupplierDateMap,finalSmallPackMap,finalGrocerySmallpackMap);
    	    		      
    		    		            
    		      }, 
    		      /**
    		       * Method sync dates basedon fulfilled by.
    		       */
    		      syncCalendarData: function(itemLevelCalendarMap, eddServiceInfoForSync, orderItemsEligibleForDelete, jsonDataForDBSave, eligibleForDBInsert, finalEddMap,finalMessageCodeMap) {
    		          let fulfillCalendarMap = eddServiceInfoForSync.fulfillCalendarMap;
    		          let fulfilledByItemLevelMap = eddServiceInfoForSync.fulfilledByItemLevelMap;
    		          let requiredkeySpecificFulfilledBy=new Map();
    		          let  fulfilledByEddMap=  eddServiceInfoForSync.fulfilledByEddMap;
    		          
    		          // US logic. Checking for errors in the service
    		          if(COSTCO.util.isUSStore()){
    		        	  let timeOutOrderId=new Set();
    		        	  for(var requiredKey of finalMessageCodeMap.keys()){
    		        		  if(finalMessageCodeMap.get(requiredKey)=='FAILURE+MSG_CODE_EXTERNAL_SERVICE_DOWN+FALSE'){
    		        			  timeOutOrderId.add(requiredKey.trim().split('_')[2])
    		        		  }
    		        		  
    		        	  }
    		        	  timeOutOrderId.forEach(orderId => {
    		        		  for(var requiredKey of finalMessageCodeMap.keys()){
    		        			  if(requiredKey.includes(orderId)){
    		        				  itemLevelCalendarMap.delete(requiredKey)
    		        				  finalEddMap.delete(requiredKey);
    		        				  finalMessageCodeMap.set(requiredKey, "FAILURE+MSG_CODE_EXTERNAL_SERVICE_DOWN+FALSE");
    		        			  }
        		        	  }
    		        		});
    		        	  
    		          }
    		            
    		          if(fulfilledByItemLevelMap!==undefined && fulfilledByItemLevelMap.size>0){
    		        	  var finalEddKeys=[];
    		        	  for(var fulfilledBy of fulfilledByItemLevelMap.keys()){
    		        		  if (fulfilledByItemLevelMap.get(fulfilledBy).constructor === String) {
    		        			  finalEddKeys.push(fulfilledByItemLevelMap.get(fulfilledBy));
		                      } else {
		                    	  finalEddKeys = fulfilledByItemLevelMap.get(fulfilledBy);
		                      }
    		        		  
    		        		  if (finalEddKeys !== null && finalEddKeys.length > 0) {
		                          for (var j = 0; j < finalEddKeys.length; j++) {
		                              if (finalEddMap.get(finalEddKeys[j]) !== undefined && fulfilledByEddMap !==undefined &&
		                            		  fulfilledByEddMap.get(fulfilledBy)!==undefined) {
		                            	  finalEddMap.set(finalEddKeys[j],fulfilledByEddMap.get(fulfilledBy));
		                              }
		                          }
		                      }
    		        		  finalEddKeys=[];
    		        	  }
    		          }
    		          
    		          
    		          var invalidFulfilledBy = eddServiceInfoForSync.InvalidFulfilledBy;
    		          if (invalidFulfilledBy.length > 0) {
    		              for (var i = 0; i < invalidFulfilledBy.length; i++) {
    		                  if (fulfilledByItemLevelMap.get(invalidFulfilledBy[i]) !== undefined) {
                                 var keyArray=[];
                                 if(fulfilledByItemLevelMap.get(invalidFulfilledBy[i]).constructor===String){
                                	 keyArray.push(fulfilledByItemLevelMap.get(invalidFulfilledBy[i]));
                                 }else{
                                	 keyArray=fulfilledByItemLevelMap.get(invalidFulfilledBy[i]);
                                 }
                                 if(keyArray.length>0){
    		                      for (var j = 0; j < keyArray.length; j++) {
    		                          itemLevelCalendarMap.delete(keyArray[j]);
    		                          finalEddMap.delete(keyArray[j]);
    		                          if(keyArray[j]!=undefined && keyArray[j].split('_').length>=3){
    		                          if (!orderItemsEligibleForDelete.has(keyArray[j].split('_')[2])) {
    		                              orderItemsEligibleForDelete.add(keyArray[j].split('_')[2]);
    		                          }
    		                          }
    		                      }
                                 }
    		                  }
    		              }
    		          }
    		          var eddOnlyFulfilledBy =  eddServiceInfoForSync.eddOnlyFulfilledBy;
    		          if (eddOnlyFulfilledBy.length > 0) {
    		              for (var i = 0; i < eddOnlyFulfilledBy.length; i++) {
    		                  if (fulfilledByItemLevelMap.get(eddOnlyFulfilledBy[i]) !== undefined) {
                                 var keyArray=[];
                                 if(fulfilledByItemLevelMap.get(eddOnlyFulfilledBy[i]).constructor===String){
                                	 keyArray.push(fulfilledByItemLevelMap.get(eddOnlyFulfilledBy[i]));
                                 }else{
                                	 keyArray=fulfilledByItemLevelMap.get(eddOnlyFulfilledBy[i]);
                                 }
                                 if(keyArray.length>0){
    		                      for (var j = 0; j < keyArray.length; j++) {
    		                          itemLevelCalendarMap.delete(keyArray[j]);
    		                          if(keyArray[j]!==undefined && keyArray[j].split('_')>=3){
    		                          if (!orderItemsEligibleForDelete.has(keyArray[j].split('_')[2])) {
    		                              orderItemsEligibleForDelete.add(keyArray[j].split('_')[2]);
    		                          }
    		                          }
    		                      }
                                 }
    		                  }
    		              }
    		          }

    		          if (itemLevelCalendarMap.size > 0) {
    		        	  var canadaCommonEddCalendarEnabled = false;
       			    	  if ((null!==$('#canadaCommonEddCalendarEnabled').val()) && (undefined!==$('#canadaCommonEddCalendarEnabled').val())){
       			    		canadaCommonEddCalendarEnabled=$('#canadaCommonEddCalendarEnabled').length > 0 && $('#canadaCommonEddCalendarEnabled').val()=='true' ? true:false;
       			    	  }
    		        	  var orderItemsList=[];
    		              var mapList = [];
    		              let firstCommonCalendarMap = new Map();
    		              let calendarMap = new Map();
    		              var firstflow = true;
    		              if (fulfillCalendarMap !== undefined && fulfillCalendarMap.size > 0) {		            	  
    		                  for (var fulfilledBy of fulfillCalendarMap.keys()) {
    		                      mapList = fulfillCalendarMap.get(fulfilledBy);
    		                      if (mapList.length > 0) {
    		                    	  if (!canadaCommonEddCalendarEnabled){
    		                    		  // this is the U.S. logic when it takes in the initial calendar and
        		                    	  // starts removing dates out of it that don't link up with the other calendars in the cart    		                    	  
        		                          for (var i = 0; i < mapList.length; i++) {
        		                              if (firstflow) {
        		                                  firstCommonCalendarMap = mapList[i];
        		                                  firstflow = false;
        		                              } else {
        		                                  calendarMap = mapList[i];
        		                                  for (var date of firstCommonCalendarMap.keys()) {
        		                                		  if (!calendarMap.has(date)) {
            		                                          firstCommonCalendarMap.delete(date);
            		                                      }  
        		                                  }
        		                              }
        		                          }		                    		           		  
    		                    	  } else {
    		                    		// get the latest start date
    		                    		  let latestStartDate = null;
    		                    		  for (var i = 0; i < mapList.length; i++) {
    		                    			  if (latestStartDate !== null){
    		                    				  if (latestStartDate < mapList[i].entries().next().value[0]) {
													latestStartDate = mapList[i].entries().next().value[0];
												}
    		                    			  } else{
    		                    				  latestStartDate = mapList[i].entries().next().value[0];
    		                    			  }  
    		                    		  }
    		                    		  
    		                    		  let convertedDate = new Date (latestStartDate);
    		                    		  let maxDate = new Date(convertedDate);
    		                    		  maxDate.setDate(maxDate.getDate() + 30); // max date is 30 days from the latestStartDate(i.e. convertedDate)
    		                    		  maxDate = maxDate.toJSON(); // toJSON to make the maxDate comparable with with EDD dates from the service
    		                    		  
    		                    		  // build the CA shared calendar, starting with the latest start date
    		                    		  for (var i = 0; i < mapList.length; i++){
    		                    			  for (var date of mapList[i].keys()) {
    		                    				  // the date is earlier than the latestStartDate or the date is 30days or later past the latestStartDate.... then don't include it in the shared calendar   		                    				  
    		                    				  if (date >= latestStartDate && date <= maxDate){
    		                    					  firstCommonCalendarMap.set(date,null);                    					  
    		                    				  }
    		                    			  }
    		                    		  }         
    		                    	  } 
    		                      }
    		                      firstflow = true;
    		                      firstCommonCalendarMap = new Map([...firstCommonCalendarMap.entries()].sort());
    		                      if (fulfilledByItemLevelMap.get(fulfilledBy).constructor === String) {
    		                          orderItemsList.push(fulfilledByItemLevelMap.get(fulfilledBy));
    		                      } else {
    		                          orderItemsList = fulfilledByItemLevelMap.get(fulfilledBy);
    		                      }
    		                      if (orderItemsList !== null && orderItemsList.length > 0) {
    		                          for (var j = 0; j < orderItemsList.length; j++) {
    		                              if (itemLevelCalendarMap.get(orderItemsList[j]) !== undefined) {
    		                            	  requiredkeySpecificFulfilledBy.set(orderItemsList[j],fulfilledBy);
    		                                  if (firstCommonCalendarMap.size > 0) {
    		                                      itemLevelCalendarMap.set(orderItemsList[j], firstCommonCalendarMap);
    		                                  } else {
    		                                      itemLevelCalendarMap.delete(orderItemsList[j]);
    		                                      if(orderItemsList[j]!==undefined && orderItemsList[j].split('_').length>=3){
    		                                      orderItemsEligibleForDelete.add(orderItemsList[j].split('_')[2]);
    		                                      }
    		                                  }
    		                              }
    		                          }
    		                      }
    		                      orderItemsList=[];

    		                  }


    		              }
    		          }
    		          eddServiceInfoForSync.requiredkeySpecificFulfilledBy=requiredkeySpecificFulfilledBy;
    		          if (eligibleForDBInsert) {
    		        	  jsonDataForDBSave.orderItemsEligibleForDelete = orderItemsEligibleForDelete;
    		          }

    		      }

    		      , populateEddService: function(orderItemSpecificSelectedDate, commonDateTimeStamp, orderItemsEligibleForDelete, orderItemSpecificEdd,
    		          itemLevelCalendarMap,  eligibleForDBInsert, finalEddMap,
    		          finalMessageCodeMap, jsonDataForDBSave,  eddServiceInfoForSync) {
    		          var orderItemSpecificFirstAvailableDate = new Map();
    		          var listOfNewFulfilledBy = [];
    		          var listOfNewItems = $('#newCalendarEligibleOrderItemIds').val();
    		          var orderItemSpecificErrorCodes='';
    		          let requiredkeySpecificFulfilledBy=eddServiceInfoForSync.requiredkeySpecificFulfilledBy;
    		          if(null !== listOfNewItems && undefined !== listOfNewItems){
    		        	  listOfNewItems = listOfNewItems.replace(/[\[\]']+/g,'').split(',');
    		        	  for(var entry of listOfNewItems){
    		    	          if(eddServiceInfoForSync.requiredkeySpecificFulfilledBy.has(entry.trim())){
    		    	        	  listOfNewFulfilledBy.push(eddServiceInfoForSync.requiredkeySpecificFulfilledBy.get(entry.trim()));
    		    	          }	  
    		              }
    		          }
    		          var onlyCalendarItemInCart = false;
    		          if (itemLevelCalendarMap.size > 0){
    		        	  var orderItemId = itemLevelCalendarMap.entries().next().value[0].split('_')[2];
    		        	  if(itemLevelCalendarMap.size === 1){
    		        		  onlyCalendarItemInCart = true;
    		        	  }else{
    		        		  for (var entry of itemLevelCalendarMap.keys()){
    		        			  var currentOrderId = entry.split('_')[2];
    		        			  if(orderItemId === currentOrderId){
    		        				  onlyCalendarItemInCart = true;
    		        			  }else{
    		        				  onlyCalendarItemInCart = false;
    		        			  }
    		        		  }
    		        	 }
    		          } else {
    		        	  $('.calendar-alert-message').addClass('hidden');
    		          }
    		          for (var item of finalMessageCodeMap.keys()) {

    		              var orderItem = item.trim().split('_')[2];
    		              var shipmode = item.trim().split('_')[4];
    		              
    		              if (finalMessageCodeMap.get(item).includes("SUCCESS")) {

    		                  COSTCO.EDDService.removeEddErrorDiv();
    		                  //display Edd for CA
    		                  if (null !== finalEddMap.get(item) && undefined !== finalEddMap.get(item) && null !== document.getElementById(item.trim() + '_edd')) {
    		                      var eddDate = finalEddMap.get(item).split('T')[0];
    		                      var date = COSTCO.EDDService.getDateFormattedToDisplay(eddDate);
    		                      var labelElement = document.createElement('label');
    		                      var spanElement = document.createElement('span');
    		                      var spanErrorElement = document.createElement('span');
    		                      spanElement.setAttribute("class", "body-copy-green bold checkout-estimated-text");
    		                      labelElement.setAttribute("class", "estimated-delivery-text");
    		                      if (undefined !== itemLevelCalendarMap.get(item)) {
    		                          labelElement.innerHTML = messages.EDD_EARLIEST_DELIVERY;
    		                      } else {
    		                          labelElement.innerHTML = messages.EARLIEST_DELIVERY_ON_TEXT_EDD;
    		                          spanErrorElement.setAttribute("class", "carrier-info edd-carrier-message-text");
    		                          spanErrorElement.innerHTML = messages.EDD_CARRIER_MSG_SHIPPING_MODE;
    		                      }
    		                      $('#eddValue_'+orderItem).val(date);
    		                      spanElement.innerHTML = date;
    		                      if(shipmode !== 'BOPIW'){
	    		                      document.getElementById(item.trim() + '_edd').innerHTML = '';
	    		                      document.getElementById(item.trim() + '_edd').appendChild(labelElement);
	    		                      document.getElementById(item.trim() + '_edd').appendChild(spanElement);
	    		                      document.getElementById(item.trim() + '_edd').appendChild(spanErrorElement);
    		                      }

    		                      if (finalEddMap.size > 0) {
    		                    	  orderItemSpecificEdd.set(item.split('_')[2],finalEddMap.get(item));
    		                      }

    		                  }


    		                  //Display Calendar
    		                  if (itemLevelCalendarMap.has(item) && null !== document.getElementById(item.trim())) {
    		                	 /* //Show Complex installation
    		                	  if (finalMessageCodeMap.get(item).split('+')[2] === 'TRUE') {
    		                		  $('#complex_installation_' + orderItem).removeClass('hidden');
    	    		              }*/
    		                	  
    		                      var listOfObjects = [];
    		                      var listOfFulfilledOrderIds = [];
    		                      var dateToDisplay = null;
    		                   
    		                      var userSelectedDate = $('#calendarItemSelectedDate').val().replace(/[\[\]']+/g, '').split(',');
    		                      const iterator1 = itemLevelCalendarMap.get(item).keys();
    		                      var earliestAvailableDate = iterator1.next().value;
    		                      var selectedDate = "";
    		                      var timeSlot = itemLevelCalendarMap.get(item).get(earliestAvailableDate);
    		                      var highlightTimeSlot;
    		                      let currentFulfilledBy = eddServiceInfoForSync.requiredkeySpecificFulfilledBy.get(item);
    		                      let fulfilledByItemLevelMap = eddServiceInfoForSync.fulfilledByItemLevelMap;
    		                      
    		                      if(fulfilledByItemLevelMap.has(currentFulfilledBy)){
    		                    	  if(Array.isArray(fulfilledByItemLevelMap.get(currentFulfilledBy))){
    		                    		  for(var entry of fulfilledByItemLevelMap.get(currentFulfilledBy)){
    		    	                    	  listOfFulfilledOrderIds.push(entry);
    		    	                      }
    		                    	  }else{
    		                    		  listOfFulfilledOrderIds.push(fulfilledByItemLevelMap.get(currentFulfilledBy));
    		                    	  }
    		                      }
    		                      if (timeSlot !== undefined && null !== timeSlot) {
    		                          if (!Array.isArray(timeSlot)) {
    		                              timeSlot = timeSlot.split();
    		                          }
    		                          highlightTimeSlot = timeSlot[0];
    		                      }

    		                      commonDateTimeStamp = COSTCO.EDDService.getTimestampDBFormat(earliestAvailableDate, timeSlot);
    		                      if(item!== undefined && item.split('_').length>=3){
    		                      orderItemSpecificFirstAvailableDate.set(item.split('_')[2],commonDateTimeStamp);
    		                      }
    		                      for (var date of itemLevelCalendarMap.get(item).keys()) {
    		                          listOfObjects.push(date);
    		                      }
    		                      if($('#newCalendarEligibleItemFound').val() === 'true' && listOfNewFulfilledBy.length > 0 && listOfNewFulfilledBy.includes(currentFulfilledBy)){
    		                    	  if (!onlyCalendarItemInCart) {
    		                    		  if(item!== undefined && item.split('_').length>=3){
    		                              orderItemSpecificSelectedDate.set(item.split('_')[2],commonDateTimeStamp);
    		                    		  }
    		                              
    		                          }
    		                          selectedDate = earliestAvailableDate;
    		                          dateToDisplay = COSTCO.EDDService.getDateFormattedToDisplay(earliestAvailableDate);
    		                	  }else {
    		                          for (var k = 0; k < userSelectedDate.length; k++) {
    		                              var selectedData = userSelectedDate[k].split('|');
    		                              if (selectedData[0].trim() === item.trim() && null !== selectedData[1] && selectedData[1] !== "") {
    		                                  if (!onlyCalendarItemInCart) {
    		                                	  if(item!== undefined && item.split('_').length>=3){
    		                                      orderItemSpecificSelectedDate.set(item.split('_')[2],selectedData[1]);
    		                                	  }
    		                                  }
    		                                  selectedDate = selectedData[1].split('T')[0];
    		                                  document.getElementById(item.trim()).setAttribute('data-selecteddate', selectedDate);
    		                                  dateToDisplay = COSTCO.EDDService.getDateFormattedToDisplay(selectedDate);
    		                                  timeSlot = itemLevelCalendarMap.get(item).get(selectedDate);
    		                                  if (null !== selectedData[2] && "null" !== selectedData[2]) {
    		                                      highlightTimeSlot = selectedData[2];
    		                                  }
    		                                  break;
    		                              }
    		                          }
    		                      }
    		                     if (null === dateToDisplay) {
    		                    	  
    		                          if (!onlyCalendarItemInCart) {
    		                        	  if(item!== undefined && item.split('_').length>=3){
    		                              orderItemSpecificSelectedDate.set(item.split('_')[2],commonDateTimeStamp);
    		                        	  }
    		                          }
    		                          selectedDate = earliestAvailableDate;
    		                          dateToDisplay = COSTCO.EDDService.getDateFormattedToDisplay(earliestAvailableDate);


    		                      }
    		                      if ($('#newCalendarEligibleItemFound').val() === 'true' && onlyCalendarItemInCart === false) {
    		                          $('.calendar-alert-message').removeClass('hidden');
    		                      } else {
    		                          $('.calendar-alert-message').addClass('hidden');
    		                      }
    		                      if (null != document.getElementById(item.trim())) {
    		                          if (onlyCalendarItemInCart === true && userSelectedDate.length === 1 && userSelectedDate[0] === "") {
    		                              $('#noDeliveryDate').val(true);
    		                              $('.calendar-label-active-field').removeClass('hidden');
    		                              $('.cart-calender-label-align').addClass('hidden');
    		                              if (undefined !== timeSlot && null !== timeSlot) {
    		                                  $('#' + item.trim() + '_timeslot').removeClass('hidden');
    		                              }
    		                          } else {
    		                        	  $('.calendar-label-active-field').addClass('hidden');
    		                              $('.cart-calender-label-align').removeClass('hidden');
    		                              document.getElementById(item.trim()).setAttribute('value', dateToDisplay);
    		                              document.getElementById(item.trim()).setAttribute('data-datetodisplay', dateToDisplay);
    		                          }
    		                          if (listOfObjects.length > 0) {
    		                              if (selectedDate !== "" && !listOfObjects.includes(selectedDate)) {
    		                            	  
    		                            	  $('#' + item.trim() + '_dateError').removeClass('hidden');
    		                            	  $('#' + item.trim()).addClass('error');
    		                                  $('#' + item.trim() + '_labelAlign').addClass('cart-calendar-label');
    		                                  $('#scheduledDeliveryDateInvalid').val(true);
    		                              }
    		                              document.getElementById(item.trim()).setAttribute('data-fulfilledorders', listOfFulfilledOrderIds);
    		                              document.getElementById(item.trim()).setAttribute('data-datelist', listOfObjects);
    		                              document.getElementById(item.trim()).setAttribute('data-commondate', earliestAvailableDate);
    		                              $('#' + item.trim() + '_div').removeClass('hidden');
    		                              if (undefined !== timeSlot && null !== timeSlot) {
    		                                  COSTCO.EDDService.displayCalendarTimeSlots(timeSlot, orderItem, selectedDate, highlightTimeSlot, item.trim());
    		                              }
    		                          }
    		                      }
    		                  }
    		                  COSTCO.EDDService.disableOrEnableProceedButton('removeAttr');
    		                  $('.selection-item').removeClass('ajax-busy');
    		                  $('.checkout-calender-spinner').addClass('hidden');
    		              } else {
    		                  let eddTireVal = item.trim().split('_')[1];
    		                  let isEddTire = eddTireVal && typeof eddTireVal === 'string' ? item.trim().split('_')[1].includes("tire") : false;
    		                  if (!isEddTire) {
    		                    orderItemSpecificErrorCodes=orderItemSpecificErrorCodes+orderItem+'+'+finalMessageCodeMap.get(item).split('+')[1]+'||';
    		                  }
		                      COSTCO.EDDService.showErrorMessageForEddItem(itemLevelCalendarMap, finalEddMap, item, finalMessageCodeMap, isEddTire);
		                  }

    		          }
    		          if( document.getElementById("orderItemSpecificErrorCodesOS")!==null){
    		        document.getElementById("orderItemSpecificErrorCodesOS").value = orderItemSpecificErrorCodes;
    		          }
                      if(document.getElementsByName("orderItemSpecificErrorCodesCC")[0]!=null){
                         document.getElementsByName("orderItemSpecificErrorCodesCC")[0].value = orderItemSpecificErrorCodes;
    		          }
      		      
    		          if (eligibleForDBInsert) {


    		        	  jsonDataForDBSave.orderItemSpecificSelectedDate = orderItemSpecificSelectedDate,
    		        	  jsonDataForDBSave.orderItemSpecificFirstAvailableDate = orderItemSpecificFirstAvailableDate,
    		        	  jsonDataForDBSave.orderItemSpecificEdd = orderItemSpecificEdd


    		          }

    		      },
    		      /**
    		       * Method return timestamp from date and timeslot with a pipe seperation.
    		       */
    		      getTimestampDBFormat: function(date, timeslots) {
    		          var times = null;;
    		          var hrMn = null;
    		          var hour = null;
    		          var min = null;
    		          var timestamp = '';
    		          if (timeslots == null) {
    		              timestamp = date + "T00:00:00";
    		              return timestamp;
    		          } else {
    		              if (timeslots.constructor === String) {
    		                  times = timeslots.split('-');
    		              } else {
    		                  times = timeslots[0].split('-');
    		              }
    		          }
    		          for (var i = 0; i < times.length; i++) {
    		              hrMn = times[i].split(':');
    		              hour = hrMn[0];
    		              if (hrMn[1].includes('PM')) {
    		                  if (hour < 12) {
    		                      hour = hour + 12;
    		                  }
    		              } else {
    		                  if (hour == 12) {
    		                      hour = '00'
    		                  } else {
    		                      hour = '0' + hour;
    		                  }
    		              }
    		              timestamp = timestamp + date + 'T' + hour + ':' + hrMn[1].replace('PM', ':00').replace('AM', ':00');
    		              if (i == 0) {
    		                  timestamp = timestamp + '|'
    		              }
    		          }
    		          return timestamp;
    		      },
    		      getDateFormattedToDisplay: function(date) {
    		    	  var splitDate = date.split('-');
    		          var year = splitDate[0];
    		          var month = splitDate[1] - 1;
    		          var day = splitDate[2];
    		          var langId = COSTCO.util.getLangId();
    		          var daysOfWeek;
    		          var monthName;
    		          var dateFormat;
    		          if(langId === '-25'){
    		        	  dateFormat = new Date(year, month, day).toLocaleDateString('fr-CA',{weekday: 'long', month : 'long', day:'numeric', year:'numeric'});
    		          }else{
    		        	  dateFormat = new Date(year, month, day).toLocaleDateString('en-US',{weekday: 'long', month : 'long', day:'numeric', year:'numeric'}); 
    		          }
    		          return dateFormat;
    		      },
    		      disableOrEnableProceedButton: function(action) {
    		          if (checkoutPage === 'cart' && null !== document.getElementById("shopCartCheckoutSubmitButton")) {
    		              if (action === 'setAttribute') {
    		                  document.getElementById("shopCartCheckoutSubmitButton").setAttribute('disabled', true);
    		              } else {
    		                  document.getElementById("shopCartCheckoutSubmitButton").removeAttribute('disabled');
    		              }
    		          } else if (checkoutPage === 'review' && null !== document.getElementById('checkout-button-wrapper')) {
    		              var button = document.getElementById('checkout-button-wrapper').querySelector('input');
    		              if (button.value === 'Place Order') {
    		                  if (action === 'setAttribute') {
    		                      document.getElementById('checkout-button-wrapper').setAttribute('disabled', true);
    		                  } else {
    		                      document.getElementById('checkout-button-wrapper').removeAttribute('disabled');
    		                  }
    		              }
    		          }
    		      },
    		      displayCalendarTimeSlots: function(timeSlot, orderItem, selectedDate, highlightTimeSlot, currentId) {

    		          if (!Array.isArray(timeSlot)) {
    		              timeSlot = timeSlot.split();
    		          }
    		          if (!timeSlot.includes(highlightTimeSlot)) {
    		              $('.calendar-time-slot-error').removeClass('hidden');
    		              $('#scheduledDeliveryDateInvalid').val(true);
    		          }
    		          $('#' + currentId + '_timeslot').removeClass('hidden');
    		          if(null !== document.getElementById(currentId)){
    		        	  document.getElementById(currentId).setAttribute('data-timeslot', highlightTimeSlot);
    		          }
    		          if(null !== document.getElementById('calendarTimeSlot')){
    		        	  document.getElementById('calendarTimeSlot').innerHTML = "";
	    		          if (timeSlot.length <= 3) {
	    		              for (var item of timeSlot) {
	    		                  var mainDiv = document.createElement('div');
	    		                  mainDiv.className = 'selection-box-v2 time-slot-main-box';
	    		                  var labelField = document.createElement('label');
	    		                  var radioElement = document.createElement("INPUT");
	    		                  radioElement.setAttribute("type", "radio");
	    		                  radioElement.setAttribute("class", "tooltip-hidden");
	    		                  radioElement.setAttribute("data-orderitem", orderItem);
	    		                  radioElement.setAttribute("data-selecteddate", selectedDate);
	    		                  radioElement.setAttribute("value", item);
	    		                  radioElement.setAttribute("onclick", "COSTCO.EDDService.saveSelectedDate.call(this)");
	    		                  radioElement.setAttribute("name", "userTimeSlot");
	    		                  var spanElement = document.createElement("span");
	    		                  if (item === highlightTimeSlot) {
	    		                      spanElement.setAttribute("class", "selection-item time-slot-body-copy time-slot-span time-slot-span-border");
	    		                  } else {
	    		                      spanElement.setAttribute("class", "selection-item time-slot-body-copy time-slot-span");
	    		                  }
	    		                  item = item.replace(/:00/g, '');
	    		                  spanElement.innerHTML = item;
	    		                  spanElement.setAttribute("onclick", "COSTCO.EDDService.saveSelectedDate.call(this)");
	
	    		                  labelField.appendChild(radioElement);
	    		                  labelField.appendChild(spanElement);
	    		                  mainDiv.appendChild(labelField);
	    		                  document.getElementById('calendarTimeSlot').appendChild(mainDiv);
	    		              }
	    		          } else {
	
	    		              for (var i = 0; i < timeSlot.length; i += 2) {
	
	    		                  var mainDiv = document.createElement('div');
	    		                  mainDiv.className = 'selection-box-v2 time-slot-main-box';
	    		                  var rowDiv = document.createElement('div');
	    		                  rowDiv.className = 'row';
	    		                  mainDiv.appendChild(rowDiv);
	    		                  var columnDiv = document.createElement('div');
	    		                  columnDiv.className = 'col-xs-6';
	    		                  var labelField = document.createElement('label');
	    		                  var radioElementFirst = document.createElement("INPUT");
	    		                  radioElementFirst.setAttribute("type", "radio");
	    		                  radioElementFirst.setAttribute("class", "tooltip-hidden");
	    		                  radioElementFirst.setAttribute("data-orderitem", orderItem);
	    		                  radioElementFirst.setAttribute("data-selecteddate", selectedDate);
	    		                  radioElementFirst.setAttribute("value", timeSlot[i]);
	    		                  radioElementFirst.setAttribute("onclick", "COSTCO.EDDService.saveSelectedDate.call(this)");
	    		                  radioElementFirst.setAttribute("name", "userTimeSlot");
	    		                  var spanElementFirst = document.createElement("span");
	    		                  spanElementFirst.innerHTML = timeSlot[i].replace(/:00/g, '');
	    		                  if (timeSlot[i] === highlightTimeSlot) {
	    		                      spanElementFirst.setAttribute("class", "selection-item time-slot-body-copy time-slot-span time-slot-span-border");
	    		                  } else {
	    		                      spanElementFirst.setAttribute("class", "selection-item time-slot-body-copy time-slot-span");
	    		                  }
	    		                  labelField.appendChild(radioElementFirst);
	    		                  labelField.appendChild(spanElementFirst);
	    		                  columnDiv.appendChild(labelField);
	    		                  var columnDivSecond = document.createElement('div');
	    		                  columnDivSecond.className = 'col-xs-6';
	    		                  var labelField2 = document.createElement('label');
	    		                  if (null !== timeSlot[i + 1]) {
	    		                      var radioElementSecond = document.createElement("INPUT");
	    		                      radioElementSecond.setAttribute("type", "radio");
	    		                      radioElementSecond.setAttribute("class", "tooltip-hidden");
	    		                      radioElementSecond.setAttribute("data-orderitem", orderItem);
	    		                      radioElementSecond.setAttribute("data-selecteddate", selectedDate);
	    		                      radioElementSecond.setAttribute("value", timeSlot[i + 1]);
	    		                      radioElementSecond.setAttribute("onclick", "COSTCO.EDDService.saveSelectedDate.call(this)");
	    		                      radioElementSecond.setAttribute("name", "userTimeSlot");
	    		                      var spanElementSecond = document.createElement("span");
	    		                      spanElementSecond.innerHTML = timeSlot[i + 1].replace(/:00/g, '');
	    		                      if (timeSlot[i + 1] === highlightTimeSlot) {
	    		                          spanElementSecond.setAttribute("class", "selection-item time-slot-body-copy time-slot-span time-slot-span-border");
	    		                      } else {
	    		                          spanElementSecond.setAttribute("class", "selection-item time-slot-body-copy time-slot-span");
	    		                      }
	    		                      labelField2.appendChild(radioElementSecond);
	    		                      labelField2.appendChild(spanElementSecond);
	    		                      columnDivSecond.appendChild(labelField2);
	    		                  }
	    		                  rowDiv.appendChild(columnDiv);
	    		                  rowDiv.appendChild(columnDivSecond);
	    		                  document.getElementById('calendarTimeSlot').appendChild(mainDiv);
	    		              }
	    		          }
    		          }  
    		      },
    		      isAdditionTransitTimeRequired: function() {
    		          var additionalTransitTimeStates = $('#additionalTransitTimeStates').val();
    		          var additionTransitTimeRequired = false;
    		          var state = $.cookie('invCheckStateCode');
    		          if (null !== state) {
    		              state = state.toUpperCase();
    		              if (additionalTransitTimeStates != null) {
    		                  for (var stateFromConf of additionalTransitTimeStates.split(",")) {
    		                      if (stateFromConf.toUpperCase() === state) {
    		                          additionTransitTimeRequired = true;
    		                          break;
    		                      }
    		                  }
    		              }
    		          }
    		          return additionTransitTimeRequired;
    		      },
    		      showErrorMessageForEddItem: function(itemLevelCalendarMap, finalEddMap, item, finalMessageCodeMap, isEddTire) {
    		    	  var orderItem = item.trim().split('_')[2];
    		          $('.checkout-calender-spinner').addClass('hidden');
    		          COSTCO.EDDService.disableOrEnableProceedButton('removeAttr');
    		          $('.selection-item').removeClass('ajax-busy');
    		          var itemNumber;
    		          var globalErrorElement = document.getElementById('notification-message');
    		          var divElement = document.createElement("div");
    		          var spanElement = document.createElement("span");
    		          var spanElementSec = document.createElement("span");
    		          if(null !== document.getElementById(item.trim())){
    		        	  var mainDiv = document.getElementById(item.trim() + '_edd_error_msg');
        		          var orderItemErrorDiv = document.getElementById('edd_service_error_'+orderItem);
        		          orderItemErrorDiv.innerHTML="";
        		          if(null !== document.getElementById('edd_service_error_'+orderItem)){
        		        	  itemNumber = document.getElementById('edd_service_error_'+orderItem).getAttribute("data-orderitemnumber");
        		          }

        		          if (finalMessageCodeMap.get(item).includes("MSG_CODE_ADDITIONAL_TRANSIT_TIME")) {
        		              spanElement.setAttribute("class", "carrier-desc-box");
        		              spanElement.innerHTML = messages.EDD_MSG_ADDITIONAL_TRANSIT_TIME;
        		              spanElementSec.setAttribute("class", "carrier-info carrier-desc-box");
        		              spanElementSec.innerHTML = messages.EDD_GUARANTEE_PRECONDITION;
        		          } else if (finalMessageCodeMap.get(item).includes("MSG_CODE_ITEM_OUT_OF_STOCK")
        		        		  || finalMessageCodeMap.get(item).includes("MSG_CODE_POSTAL_CODE_RESTRICTED")) {
        		              spanElement.setAttribute("class", "warning carrier-desc-box");
        		              spanElement.innerHTML = messages.ORDER_BYITEM_OUT_STOCK;
        		              orderItemErrorDiv.innerHTML = messages.EDD_ERR_SHIP_MSG.replace(/\{0\}/g, itemNumber);
        		              $('#edd_service_error_'+orderItem).removeClass('hide'); 
        		              $('#edd_service_error_'+orderItem).removeClass('hidden'); 
        		              $('#edd_error_' + orderItem).removeClass('hidden');
        		              if(isEddTire) {
        		            	if (document.getElementsByClassName('critical-notification order-error eddtire').length == 0) {
        		                  divElement.setAttribute("class", "critical-notification order-error eddtire");
        		                  divElement.innerHTML = messages._ERR_EDD_TIRE_INV_GLOBAL;
        		            	}
        		                $('#tire_text_'+orderItem).addClass('hide');
        		              }
        		          }else if (finalMessageCodeMap.get(item).includes("MSG_CODE_UNKNOWN_ERROR") 
        		        		  || finalMessageCodeMap.get(item).includes("MSG_CODE_EXTERNAL_SERVICE_DOWN")){
        		        	  orderItemErrorDiv.innerHTML = messages.EDD_UNKNOWN_ERROR;
        		        	  $('#edd_error_' + orderItem).removeClass('hidden');
        		        	  $('#edd_service_error_'+orderItem).removeClass('hidden');
        		              $('#edd_service_error_'+orderItem).removeClass('hide');  
        		          }else {
        		              spanElement.setAttribute("class", "carrier-desc-box");
        		              spanElement.innerHTML = messages.EDD_GENERIC_SHIPPING_CLAUSE;
        		              if (undefined === itemLevelCalendarMap.get(item)) {
        		                  spanElementSec.setAttribute("class", "carrier-info carrier-desc-box");
        		                  spanElementSec.innerHTML = messages.EDD_CARRIER_MSG_WITH_NO_EDD;
        		              }
        		          }
        		          mainDiv.innerHTML = "";
        		          mainDiv.appendChild(spanElement);
        		          mainDiv.appendChild(spanElementSec);
        		          globalErrorElement.appendChild(divElement);
    		          }
    		      },
    		      checkIfEDDInValidRange: function(date) {
    		          date = date.split('T')[0].split('-');
    		          var rangeValid = false;
    		          var eddMaxFutureDateDiff;
    		          if(typeof $('#eddMaxFutureDateDiff').val() !== 'undefined'){
    		        	  eddMaxFutureDateDiff = parseInt($('#eddMaxFutureDateDiff').val());
    		          }
    		          var year = date[0];
    		          var month = date[1] - 1;
    		          var day = date[2];
    		          const eddDate = new Date(year, month, day);
    		          const today = new Date();
    		          const diffTime = Math.abs(eddDate - today);
    		          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    		          if (diffDays <= eddMaxFutureDateDiff) {
    		              rangeValid = true;
    		          }
    		          return rangeValid;
    		      },
    		  removeEddErrorDiv :function(){
    			  
    			  $('.edd-transit-time-msg').addClass('hidden');
    			  $('#edd-outofstock').addClass('hidden');
    			  $('.scheduler-msg').addClass('hidden');
    			  
    		  },
    		  createCalendarInput :function(jsonDataForDBSave,currentId){
    			  
    			  var shipMode = currentId.split('_')[3];
    			  var orderItemId = currentId.split('_')[2];
    			  var existingDiv = document.getElementById(currentId.trim());
    			  var labelElement = document.createElement("label");
    			  var inputElement = document.createElement("input");
    			  if(existingDiv!==undefined && existingDiv!==null){
	  				$('#'+currentId).addClass('hidden');
	  				var mainDiv = document.getElementById("calendarWrap_"+currentId);
	  				labelElement.setAttribute("id", "for-Canada_"+currentId);
	  				labelElement.setAttribute("class", "label-outline hidden");
	  				inputElement.setAttribute("tabindex", "0");
	  				inputElement.setAttribute("onblur", "COSTCO.util.changeTabIndexOut(this);");
	  				inputElement.setAttribute("onfocus", "COSTCO.util.changeTabIndex();");
	  				inputElement.setAttribute("data-currentdate",existingDiv.getAttribute('data-currentdate'));
	  				inputElement.setAttribute("onkeypress","if(event.keyCode === 13) COSTCO.OrderItems.date_picker_scheduler.call(this,"+shipMode+")");
	  				inputElement.setAttribute("name", "date_"+orderItemId);
	  				inputElement.setAttribute("onclick", "COSTCO.OrderItems.date_picker_scheduler.call(this,"+shipMode+")");
	  				if(COSTCO.util.isCAStore() && COSTCO.util.getLangId() === "-25"){
	  					inputElement.setAttribute("value", COSTCO.EDDService.getDateFormattedToDisplay(jsonDataForDBSave.dateFormatted));
	  				}else{
	  					inputElement.setAttribute("value", jsonDataForDBSave.selectedDeliveryDate);
	  				}
	  				inputElement.setAttribute("class", "date-input date-input-field form-control");
	  				inputElement.setAttribute("type", "text");
	  				inputElement.setAttribute("id", currentId);
	  				inputElement.setAttribute("data-orderitem",orderItemId );
	  				inputElement.setAttribute("data-datelist",existingDiv.getAttribute('data-datelist') );
	  				inputElement.setAttribute("data-commondate",existingDiv.getAttribute('data-commondate') );
	  				inputElement.setAttribute("data-fulfilledorders",existingDiv.getAttribute('data-fulfilledorders') );
	  				inputElement.setAttribute("data-timeslot",existingDiv.getAttribute('data-timeslot') );
	  				inputElement.setAttribute("data-selecteddate",existingDiv.getAttribute('data-selecteddate') );
	  				inputElement.setAttribute("data-datetodisplay",existingDiv.getAttribute('data-datetodisplay') );
	  				inputElement.setAttribute("data-shipcode",existingDiv.getAttribute('data-shipcode') );
	  				mainDiv.innerHTML = "";
	  				mainDiv.appendChild(labelElement);
	  				mainDiv.appendChild(inputElement);
    			  }
    		  },
    		  populateSmallPackEDD :function(finalShipCodeMap,jsonDataForDBSave,eligibleForDBInsert,
    				  finalSmallPackSupplierDateMap,finalSmallPackMap,finalGrocerySmallpackMap){
    			  var orderItemSpecificEdd = new Map();
    			  var orderItemsEligibleForDelete= new Set();
    			  if(eligibleForDBInsert){
    				  if(jsonDataForDBSave.orderItemSpecificEdd!==undefined){
    				  orderItemSpecificEdd = jsonDataForDBSave.orderItemSpecificEdd; 
    				  }
    				  if(jsonDataForDBSave.orderItemsEligibleForDelete!==undefined){
    					  orderItemsEligibleForDelete = jsonDataForDBSave.orderItemsEligibleForDelete; 
        				  }
    			  }else{
    				  jsonDataForDBSave = {
		                      mode: 'APICALL',
		                      orderId: $('input[name=orderId]').val(),
		  		              orderItemsSupplierAvailabilityDate:new Map()
		                  }; 
    			  }
    			  
    			  for (var orderItemId of finalSmallPackMap.keys()) {
    				 for (var shipCode of finalSmallPackMap.get(orderItemId).keys()) {
    					 
    					 var shipCodeData = finalSmallPackMap.get(orderItemId).get(shipCode);
    					 
    					 if (shipCodeData.selectable) {
    						 var shipCodeToSelect = shipCodeData;
    					 }
    						     					 
    				     if (shipCodeData.hide) {
    				    	 var selector = COSTCO.util.messageFormat(COSTCO.OrderItems.shipMethodSelector, orderItemId, shipCodeData.shipModeId);
    				    	 COSTCO.OrderItems.disableShipMethodCode(selector);
    				    	 // if ship mode is selected, but asked to be hidden - handle the selection of prior ship mode, if it exists
    				    	 if (shipCodeData.selected) {
    				    	 	 COSTCO.OrderItems.selectCorrectShipMode(orderItemId,shipCodeToSelect);
    				    	 }
    				     }
    				     
    				     if (null != shipCodeData.edd) {
    				    	 var smallPackEDD = shipCodeData.edd.split('T')[0];
        				     var date = COSTCO.EDDService.getDateFormattedToDisplay(smallPackEDD);
        				     
        				     // display on screen
        				     var labelElement = document.createElement('label');
    	                     var spanElement = document.createElement('span');
    	                     spanElement.setAttribute("class", "body-copy-green bold checkout-estimated-text");
    	                     labelElement.setAttribute("class", "estimated-delivery-text");
                             labelElement.innerHTML = messages.EMAIL_TEXT_EST_DELIVERY_DATE;
                             $('#eddValue_'+orderItemId).val(date);
    	                     spanElement.innerHTML = date;
    	                     
    	                     if (null !== document.getElementById(shipCodeData.screenField.trim())){
    		                      document.getElementById(shipCodeData.screenField.trim()).innerHTML = '';
    		                      document.getElementById(shipCodeData.screenField.trim()).appendChild(labelElement);
    		                      document.getElementById(shipCodeData.screenField.trim()).appendChild(spanElement);
    	                     }
    				     }
    				     
    				     // prepare for DB save
	                     if (shipCodeData.selected) {
	                    	 if (shipCodeData.edd) {
	                    		 orderItemSpecificEdd.set(orderItemId, shipCodeData.edd); 
	                    	 } else {
	                    		 orderItemsEligibleForDelete.add(orderItemId);
	                    	 }
	                    	 if (shipCodeData.supplierDate) {
	                    		 jsonDataForDBSave.orderItemsSupplierAvailabilityDate.set(orderItemId, shipCodeData.supplierDate);
	                    	 } else {
	                    		 jsonDataForDBSave.orderItemsSupplierAvailabilityDate.set(orderItemId,'DELETE');
	                    	 }
	                     }
    				  }
    			  }
    			  
    			  var smallpackEligibleGroceryItems=$('#smallPackGroceryEligibleItems').val();
    			  if (smallpackEligibleGroceryItems !== undefined && 
		        		  null !== smallpackEligibleGroceryItems && smallpackEligibleGroceryItems.length>0) {
		        	  smallpackEligibleGroceryItems = smallpackEligibleGroceryItems.replace('[', '').replace(']', ' ').replace(/\s+/g, '').split(',');
    			  }
    			  if(finalGrocerySmallpackMap.size>0){
    				  var groceryEddDate=finalGrocerySmallpackMap.get('EDD');
    				  if(undefined !==groceryEddDate &&  null !== groceryEddDate){
    					  COSTCO.EDDService.populateGroceryEDD(groceryEddDate); 
    				  }
    				  var grocerySupplierDate=finalGrocerySmallpackMap.get('SUPPLIER_DATE');
    		          
    		          if(smallpackEligibleGroceryItems.constructor===Array){
                          for (var k = 0; k < smallpackEligibleGroceryItems.length; k++) {
                        	 if( smallpackEligibleGroceryItems[k].length>0){
                        		 orderItemSpecificEdd.set(smallpackEligibleGroceryItems[k],groceryEddDate);
                        		 if(undefined !== grocerySupplierDate && null!== grocerySupplierDate){
    
                        			 jsonDataForDBSave.orderItemsSupplierAvailabilityDate.set(smallpackEligibleGroceryItems[k],grocerySupplierDate);
                        		 }else{
                        			 jsonDataForDBSave.orderItemsSupplierAvailabilityDate.set(smallpackEligibleGroceryItems[k],'DELETE');
                        			 
                        		 }
	                        	  
                        	 }
                          
                       }
    		          }
    		          
    			  }else{
    				  
    		          if(smallpackEligibleGroceryItems.constructor===Array){
                          for (var k = 0; k < smallpackEligibleGroceryItems.length; k++) {
                        	 if( smallpackEligibleGroceryItems[k].length>0){
                        		 orderItemsEligibleForDelete.add(smallpackEligibleGroceryItems[k]);
                        	 }
                          }
    		          }
    			  }
    			  jsonDataForDBSave.orderItemSpecificEdd = orderItemSpecificEdd; 
    			  jsonDataForDBSave.orderItemsEligibleForDelete = orderItemsEligibleForDelete;
        			  if(!eligibleForDBInsert){
        				  COSTCO.OrderItems.ajaxCalendarDataUpdate(jsonDataForDBSave);
        			  }
    			  
    		  },
    		  populateGroceryEDD :function(groceryEddDate){
    			  var date = COSTCO.EDDService.getDateFormattedToDisplay(groceryEddDate.split('T')[0]);
    			  var labelElement = document.createElement('span');
                  var spanElement = document.createElement('span');
                  spanElement.setAttribute("class", "body-copy-green bold");
                  labelElement.innerHTML = messages.EDD_DELIVERED_ON_TEXT;
                  spanElement.innerHTML = "    "+date;
                  if(null !== document.getElementById('smallpack_grocery_Edd')){
                      document.getElementById('smallpack_grocery_Edd').innerHTML = '';
                      document.getElementById('smallpack_grocery_Edd').appendChild(labelElement);
                      document.getElementById('smallpack_grocery_Edd').appendChild(spanElement);
                  }
    			  
    		  },
    		  getRollbackTime :function(requestJson,eddConnectionTime,smallPackConnectiontimeOut){
    			  var totalRequestCount=requestJson.length;
    			  var  timeout= totalRequestCount*(+eddConnectionTime+1000);
    			  try {
    			  if(typeof requestJson !== 'undefined' && null !== requestJson){
    				 var smallPackCount= requestJson.split('smallpack').length-1;
    				 if(smallPackCount>0){
    					 timeout= ((totalRequestCount-smallPackCount)*(+eddConnectionTime+1000))+smallPackCount*(+smallPackConnectiontimeOut+1000);
    				 }
    			  }
    			  }catch(err) {
    				  console.log(' Error occurred while processing timeout '+err);
    				
    			  }
    			  return timeout;
    		  },
    		  stringifyJsonData :function(data){
    			  if(undefined !== data.orderItemsSpecificFulfilledBy){
    				  data.orderItemsSpecificFulfilledBy= JSON.stringify([...data.orderItemsSpecificFulfilledBy]);  
    			  }
    			  if(undefined !== data.orderItemsSpecificFulfilledType){
    				  data.orderItemsSpecificFulfilledType= JSON.stringify([...data.orderItemsSpecificFulfilledType]);  
    			  }
    			  if(undefined !== data.orderItemSpecificEdd){
    				  data.orderItemSpecificEdd=JSON.stringify([...data.orderItemSpecificEdd]);
    			  }
    			  if(undefined !== data.orderItemsEligibleForDelete){
    				  data.orderItemsEligibleForDelete=JSON.stringify([...data.orderItemsEligibleForDelete]);
    			  }
    			  if(undefined !== data.orderItemsSupplierAvailabilityDate){
    				  data.orderItemsSupplierAvailabilityDate=JSON.stringify([...data.orderItemsSupplierAvailabilityDate]);
    			  }
    			  if(undefined !== data.orderItemSpecificSelectedDate){
    				  data.orderItemSpecificSelectedDate = JSON.stringify([...data.orderItemSpecificSelectedDate]);
    			  }
    			  if(undefined !== data.orderItemSpecificFirstAvailableDate){
    				  data.orderItemSpecificFirstAvailableDate = JSON.stringify([...data.orderItemSpecificFirstAvailableDate]);
    			  }
    			  if(undefined !== data.EDDRequestTransactionId){
    				  data.EDDRequestTransactionId = JSON.stringify([...data.EDDRequestTransactionId]);
    			  }
    			  if(undefined !== data.orderItemWebCatalogId){
    				  data.orderItemWebCatalogId = JSON.stringify([...data.orderItemWebCatalogId]);
    			  }
    			  if(undefined !== data.orderItemsTransportPriority){
    				  data.orderItemsTransportPriority = JSON.stringify([...data.orderItemsTransportPriority]);
    				  
    			  }
    			  if(undefined !== data.orderItemsSupplier){
    				  data.orderItemsSupplier = JSON.stringify([...data.orderItemsSupplier]);
    				  
    			  }
    		  },
    		  getDefaultShipcodeForNonDeluxingItems  :function(selectedOrderItemShipcodeList,jsonResponse){
    			  if(selectedOrderItemShipcodeList !== undefined && null !== selectedOrderItemShipcodeList && selectedOrderItemShipcodeList.length>0 && 
	    		      selectedOrderItemShipcodeList.includes(jsonResponse.orderItemId)){
    				  var defaultOrderItemIdShipCodeList = selectedOrderItemShipcodeList.replace('[', '').replace(']', ' ').replace(/\s+/g, '').split(',');
		    			  for (const element of defaultOrderItemIdShipCodeList) {
		    				  if(element.includes(jsonResponse.orderItemId)){
		    				    var orderItemIdShipCodeArray=element.split('_');
		    				    if(orderItemIdShipCodeArray.length==2){
		    				    	jsonResponse.shipmodeDates[0].shippingCode=orderItemIdShipCodeArray[1];
		    				    }
		    				   break;
		    				  }
	    				  }
    			   }
    		  }
    }
    if (typeof window.COSTCO === 'undefined') {
        window.COSTCO = new Object();
      }

      typeof window.COSTCO.Global == 'undefined' ?
        document.addEventListener('EDDServiceLoaded', EDDService.loaded, false) :
        	EDDService.loaded();

      window.COSTCO.EDDService = EDDService;

      return EDDService;
    
  });


// WEBPACK FOOTER //
// ./js/checkout/eddservice.js